<template>
  <v-layout align-start>
  <v-flex>
    <v-data-table
      :headers="headers"
      :items="movimientosAgenciamientoLista"
      :search="search"
      class="elevation-1"
      v-if="verNuevo==0"
    >
   <template v-slot:item.estado="{ item }">
         <v-chip small class="ma-2" color="orange" text-color="white"  v-if="item.estado==0">
          <v-avatar left>
            <v-icon small>restore</v-icon>
          </v-avatar>
            En borrador
         </v-chip>

         <v-layout v-if="item.estado==1">
           <v-icon color="success" dense small>check</v-icon>
         </v-layout>

        <v-layout v-if="item.estado==2">
            <v-icon color="success" dense small>check</v-icon>
            <v-icon color="#31467C" dense small>check</v-icon>
        </v-layout>

         <v-layout v-if="item.estado==3">
            <v-icon color="success" dense small>check</v-icon>
             <v-icon color="#31467C" dense small>check</v-icon>
            <v-icon color="pink" dense small>check</v-icon>
        </v-layout>

         <v-layout v-if="item.estado==4">
            <v-icon color="success" dense small>check</v-icon>
             <v-icon color="#31467C" dense small>check</v-icon>
            <v-icon color="pink" dense small>check</v-icon>
            <v-icon color="orange" dense small>check</v-icon>
        </v-layout>

         <v-layout v-if="item.estado==5">
            <v-icon color="success" dense small>check</v-icon>
             <v-icon color="#31467C" dense small>check</v-icon>
            <v-icon color="pink" dense small>check</v-icon>
            <v-icon color="orange" dense small>check</v-icon>
            <v-icon color="red" dense small>check</v-icon>
        </v-layout>
      

    </template>
       <template v-slot:item.tiempoRestante="{ item }">

         </template>
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Movimientos AMLS</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-spacer></v-spacer>
          <v-text-field class="text-xs-center" v-if="verNuevo==0" v-model="search" append-icon="search" label="Busqueda" single-line hide-details></v-text-field>
          <v-spacer></v-spacer>   
      
  <v-spacer></v-spacer> 
                   <v-btn v-if="verNuevo==0" @click="mostrarNuevo()"  small>Nuevo Movimiento</v-btn>
         
        
       
          <v-dialog v-model="adModal" max-width="290">
            <v-card>
              <v-card-title class="headline" v-if="adAccion==1">
                  Activar Item
              </v-card-title>
              <v-card-title class="headline" v-if="adAccion==2">
                  Desactivar Item
              </v-card-title>

              <v-card-text>
                  Estas a punto de <span v-if="adAccion==1">Activar</span>
                  <span v-if="adAccion==2">Desactivar</span> la solicitud con folio {{adNombre}}
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="activarDesactivarCerrar()" color="green darken-1" flat="flat">
                  Cancelar
                </v-btn>
                 <v-btn v-if="adAccion==1" @click="activar()" color="orange darken-4" flat="flat">
                   Aprobar
                </v-btn>
                <v-btn v-if="adAccion==2" @click="desactivar()" color="orange darken-4" flat="flat">
                  Desactivar
                </v-btn>

              </v-card-actions>

            </v-card>
          </v-dialog>
       <v-dialog v-model="comprobanteModal" max-width="1100px">
            <v-card>
              <v-card-title class="headline">
                    <v-card-actions>
                    <v-btn @click="ocultarComprobante()">Salir</v-btn>
                    <v-btn @click="imprimir()">
                      <v-icon>print</v-icon>Imprimir
                    </v-btn>
                  </v-card-actions>
              </v-card-title>
              <v-card-text>
                <div id="solicitudGuardia">
                    <br />
                    <br />
                    
                    <header>
                    
                      <link
                        rel="stylesheet"
                        media="print"
                        href="https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/css/bootstrap.min.css"
                        integrity="sha384-Vkoo8x4CGsO3+Hhxv8T/Q5PaXtkKtu6ug5TOeNV6gBiFeWPGFN9MuhOf23Q9Ifjh"
                        crossorigin="anonymous"
                      />

                      <link
                        rel="stylesheet"
                        media="screen"
                        href="https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/css/bootstrap.min.css"
                        integrity="sha384-Vkoo8x4CGsO3+Hhxv8T/Q5PaXtkKtu6ug5TOeNV6gBiFeWPGFN9MuhOf23Q9Ifjh"
                        crossorigin="anonymous"
                      />
                    </header>
                    <div id="agencia">
                      <div style="float: left; margin-left:2%;margin-right:2%">
                        <img
                          style="width:100px"
                          src="data:image/png;base64,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"
                          id="imagen"
                        />
                      </div>
                    
                      <div style="float:left;margin-top:0%;margin-left:15%;margin-right:2%">
                        <p
                          style="text-align:center;margin-left:10px;margin-right:10px;font-size:16px"
                        >
                          <strong id="texto">Movimiento de Agenciamiento</strong>
                          <br />
                          <strong id="texto">AG-{{folioAg}}</strong>
                          <br />
                        </p>
                      </div>
                      <br />

                      <br />
                      <div id="texto" style="margin-left: 66%;">
                        Ciudad del Carmen, Campeche. a: {{fecha}}
                        <br />
                      </div>
                      <br />
                      <p id="texto">
                       El siguiente reporte muestra los detalles de los servicios de agenciamiento realizados con la embarcación 
                      <strong id="texto">{{embarcacion.nombre}}</strong> el cual tuvo un arribo el dia  <strong id="texto">{{atraqueFecha}}</strong>
                      y un desatraque el día <strong id="texto">{{desatraqueFecha}}</strong> en el puerto de <strong id="texto">{{puerto}}</strong> 
                      para realizar un programa de <strong id="texto">{{programa}}</strong>
                      </p> 

                    
                    </div>
                    <br />

                    <div id="agencia">
                      <table style="width: 100%; height: 50px;">
                        <tbody>
                          <tr>
                            <td id="texto" style="border: hidden">Razon Social</td>

                            <td id="texto" style="border-bottom: .5px solid">{{cliente}}</td>
                          </tr>

                          <tr>
                            <td id="texto" style="border: hidden">RFC</td>

                            <td id="texto" style="border-bottom: .5px solid"></td>
                          </tr>

                          <tr>
                            <td id="texto" style="border: hidden">Nombre Comercial</td>

                            <td
                              id="texto"
                              style="border-bottom: .5px solid"
                            ></td>
                          </tr>
                        </tbody>
                      </table><br>


                     

                   

                    <table style="width: 100%; height: 100px;">
                        <thead style=" background-color:gray; color:black;">
                          <tr>
                            <th colspan="11">Características de la Embarcación</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td id="texto" colspan="3">Nombre de la embarcación</td>
                            <td
                              id="texto"
                              colspan="8"
                              style="border-bottom: 1px solid"
                            >{{embarcacion.nombre}}</td>
                          </tr>
                          <tr>
                            <td colspan="3" style="border-color:white"></td>
                            <td colspan="8"></td>
                          </tr>
                        </tbody>

                      

                        <tbody style="border-color:white">
                          <tr>
                            <td id="texto" style="border-color:white">Tipo</td>
                            <td id="texto" style="border-bottom: 1px solid">{{embarcacion.tipo}}</td>

                            <td id="texto">Bandera</td>
                            <td id="texto" style="border-bottom: 1px solid">{{embarcacion.bandera}}</td>
                            <td id="texto">T.R.B.</td>
                            <td id="texto" style="border-bottom: 1px solid">{{embarcacion.tbr}}</td>
                            <td id="texto">Eslora</td>
                            <td id="texto" style="border-bottom: 1px solid">{{embarcacion.eslora}}</td>
                            <td id="texto">Manga</td>
                            <td id="texto" style="border-bottom: 1px solid">{{embarcacion.manga}}</td>

                            <td></td>
                          </tr>
                          <tr>
                            <td style="border-color:white"></td>
                            <td></td>

                            <td style="border-color:white"></td>
                            <td></td>
                            <td style="border-color:white"></td>
                            <td></td>
                            <td style="border-color:white"></td>
                            <td></td>
                            <td style="border-color:white"></td>
                            <td></td>
                          </tr>
                        </tbody>
                      </table>

                      <br />

                      
                    <table v-if="pilotoEntradaEntidad" style="width: 100%; height: 100px;">
                        <thead style=" background-color:gray; color:black;">
                          <tr>
                            <th colspan="11">Pilotos y Lanchaje</th>
                          </tr>
                        </thead>
                  
                        <tbody>
                           <tr>
                              <th style="color:black">Piloto Entrada</th>
                              <td style="color:#9e0059; font-weight:bold">{{pilotoEntrada}}</td>
                              <th style="color:black">Tiempo</th>
                              <td style="color:#9e0059; font-weight:bold">{{pilotoEntradaTiempo}}</td>
                              <th style="color:black">Enlace a Factura</th>
                              <td style="color:#9e0059; font-weight:bold"><a style="color:#9e0059; font-weight:bold" :href="pilotoEntradaEnlace" target="_blank">{{pilotoEntradaNoFactura}}</a></td>
                            </tr>
                           <tr>
                              <th style="color:black">Piloto Salida</th>
                              <td style="color:#9e0059; font-weight:bold">{{pilotoSalida}}</td>
                              <th style="color:black">Tiempo</th>
                              <td style="color:#9e0059; font-weight:bold">{{pilotoSalidaTiempo}}</td>
                              <th style="color:black">Enlace a Factura</th>
                              <td style="color:#9e0059; font-weight:bold"><a style="color:#9e0059; font-weight:bold" :href="pilotoSalidaEnlace" target="_blank">{{pilotoSalidaNoFactura}}</a></td>
                            </tr>
                          
                            <tr>
                              <th style="color:black">Lanchaje Entrada</th>
                              <td style="color:#9e0059; font-weight:bold">{{lanchajeEntrada}}</td>
                              <th style="color:black">Tiempo</th>
                              <td style="color:#9e0059; font-weight:bold">{{lanchajeEntradaTiempo}}</td>
                              <th style="color:black">Enlace a Factura</th>
                              <td style="color:#9e0059; font-weight:bold"><a style="color:#9e0059; font-weight:bold" :href="lanchajeEntradaEnlace" target="_blank">{{lanchajeEntradaNoFactura}}</a></td>
                            </tr>

                              <tr>
                              <th style="color:black">Lanchaje Salida</th>
                              <td style="color:#9e0059; font-weight:bold">{{lanchajeSalida}}</td>
                              <th style="color:black">Tiempo</th>
                              <td style="color:#9e0059; font-weight:bold">{{lanchajeSalidaTiempo}}</td>
                              <th style="color:black">Enlace a Factura</th>
                              <td style="color:#9e0059; font-weight:bold"><a style="color:#9e0059; font-weight:bold" :href="lanchajeSalidaEnlace" target="_blank">{{lanchajeSalidaNoFactura}}</a></td>
                            </tr>
                           
                        </tbody>

                      </table>
                      

                      <table v-if="adminpi.length>0" style="width: 100%; height: 100px; border: 1px solid #000000;">
                        <thead
                          style="background-color:gray; color:black; border: 1px solid #000000;"
                        >
                          <tr>
                            <th colspan="8">Administración Portuaria Integral</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr style="border: 1px solid #000000;">
                          
                            <td
                              id="texto"
                              style="border: 1px solid #000000;font-weight:bold; text-align:center"
                            >Numero de Factura</td>
                            <td
                              id="texto"
                              style="border: 1px solid #000000;font-weight:bold; text-align:center"
                            >Movimiento</td>
                            <td
                              id="texto"
                              style="border: 1px solid #000000;font-weight:bold; text-align:center"
                            >Fecha del Servicio</td>
                            <td
                              id="texto"
                             style="border: 1px solid #000000;font-weight:bold; text-align:center"
                            >Enlace a Factura</td>
                          
                          </tr>
                          <tr v-for="(det) in adminpi" :key="det._id">
                         

                            <td
                              id="texto"
                              style="border: 1px solid #000000; color:#2c699a;font-weight:bold;text-align:center"
                            >{{det.noFactura}}</td>
                             <td
                              id="texto"
                              style="border: 1px solid #000000; color:#2c699a;font-weight:bold;text-align:center"
                            >{{det.movimientoApi}}</td>
                            <td
                              id="texto"
                              style="border: 1px solid #000000; color:#2c699a;font-weight:bold;text-align:center"
                            >{{det.fechaServicio}}</td>
                            <td
                              id="texto"
                              style="border: 1px solid #000000; color:#2c699a;font-weight:bold;text-align:center"
                            ><a style="color:#2c699a; font-weight:bold" :href="det.enlaceFactura" target="_blank">Enlace</a></td>
                          </tr>
                        </tbody>
                      </table>


                       <br />

                          <table  v-if="capitania.length>0" style="width: 100%; height: 100px; border: 1px solid #000000;">
                        <thead
                          style="background-color:gray; color:black; border: 1px solid #000000;"
                        >
                          <tr>
                            <th colspan="8">Secretaria de Marina</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr style="border: 1px solid #000000;">
                          
                            <td
                              id="texto"
                              style="border: 1px solid #000000;font-weight:bold; text-align:center"
                            >Factura</td>
                            <td
                              id="texto"
                              style="border: 1px solid #000000;font-weight:bold; text-align:center"
                            >Hoja de Ayuda</td>
                            <td
                              id="texto"
                             style="border: 1px solid #000000;font-weight:bold; text-align:center"
                            >Tipo de Servicio</td>
                           
                          
                          </tr>
                          <tr v-for="(det) in capitania" :key="det._id">
                         
                            <td
                              id="texto"
                              style="border: 1px solid #000000; color:#ff0054;font-weight:bold;text-align:center"
                            ><a style="color:#ff0054; font-weight:bold" :href="det.enlaceFacturaCapitania" target="_blank">{{det.noFactura}}</a></td>
                        
                            <td
                              id="texto"
                              style="border: 1px solid #000000; color:#ff0054;font-weight:bold;text-align:center"
                            ><a style="color:#ff0054; font-weight:bold" :href="det.enlaceHojaAyudaCapitania" target="_blank">{{det.noHojaAyuda}}</a></td>
                             <td
                              id="texto"
                              style="border: 1px solid #000000; color:#ff0054;font-weight:bold;text-align:center"
                            >{{det.tipoServicio}}</td>
                      
                          </tr>
                        </tbody>
                      </table><br>


                     <table   v-if="enmiendaPilotos.length>0" style="width: 100%; height: 100px; border: 1px solid #000000;">
                        <thead
                          style="background-color:gray; color:black; border: 1px solid #000000;"
                        >
                          <tr>
                            <th colspan="8">Enmienda Piloto</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr style="border: 1px solid #000000;">
                          
                            <td
                              id="texto"
                              style="border: 1px solid #000000;font-weight:bold; text-align:center"
                            >Fecha y Hora</td>
                            <td
                              id="texto"
                              style="border: 1px solid #000000;font-weight:bold; text-align:center"
                            >Movimiento</td>
                            <td
                              id="texto"
                             style="border: 1px solid #000000;font-weight:bold; text-align:center"
                            >Piloto</td>
                            <td
                              id="texto"
                             style="border: 1px solid #000000;font-weight:bold; text-align:center"
                            >Enlace</td>
                          
                          </tr>
                          <tr v-for="(det) in enmiendaPilotos" :key="det._id">
        
                            <td
                              id="texto"
                              style="border: 1px solid #000000; color:#ffbd00;font-weight:bold;text-align:center"
                            >{{det.fechaHoraPilotoEnmienda | moment("dddd Do MMMM YYYY")}}</td>
                             <td
                              id="texto"
                              style="border: 1px solid #000000; color:#ffbd00;font-weight:bold;text-align:center"
                            >{{det.movimientoPilotoEnmienda}}</td>
                                <td
                              id="texto"
                              style="border: 1px solid #000000; color:#ffbd00;font-weight:bold;text-align:center"
                            >{{det.PilotoEnmienda}}</td>
                           <td
                              id="texto"
                              style="border: 1px solid #000000; color:#ffbd00;font-weight:bold;text-align:center"
                            ><a style="color:#ffbd00; font-weight:bold" :href="det.enlacePilotoEnmienda" target="_blank">Enlace</a></td>
                          </tr>
                        </tbody>
                      </table><br>

                          <table v-if="enmiendaLanchaje.length>0" style="width: 100%; height: 100px; border: 1px solid #000000;">
                        <thead
                          style="background-color:gray; color:black; border: 1px solid #000000;"
                        >
                          <tr>
                            <th colspan="8">Enmienda Lanchaje</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr style="border: 1px solid #000000;">
                          
                            <td
                              id="texto"
                              style="border: 1px solid #000000;font-weight:bold; text-align:center"
                            >Fecha y Hora</td>
                            <td
                              id="texto"
                              style="border: 1px solid #000000;font-weight:bold; text-align:center"
                            >Movimiento</td>
                            <td
                              id="texto"
                             style="border: 1px solid #000000;font-weight:bold; text-align:center"
                            >Piloto</td>
                            <td
                              id="texto"
                             style="border: 1px solid #000000;font-weight:bold; text-align:center"
                            >Enlace</td>
                          
                          </tr>
                          <tr v-for="(det) in enmiendaLanchaje" :key="det._id">
        
                            <td
                              id="texto"
                              style="border: 1px solid #000000; color:#ffbd00;font-weight:bold;text-align:center"
                            >{{det.fechaHoraLanchajeEnmienda | moment("dddd Do MMMM YYYY")}}</td>
                             <td
                              id="texto"
                              style="border: 1px solid #000000; color:#ffbd00;font-weight:bold;text-align:center"
                            >{{det.movimientoLanchajeEnmienda}}</td>
                                <td
                              id="texto"
                              style="border: 1px solid #000000; color:#ffbd00;font-weight:bold;text-align:center"
                            >{{det.lanchajeEnmienda}}</td>
                           <td
                              id="texto"
                              style="border: 1px solid #000000; color:#ffbd00;font-weight:bold;text-align:center"
                            ><a style="color:#ffbd00; font-weight:bold" :href="det.enlanceLanchajeEnlace" target="_blank">Enlace</a></td>
                          </tr>
                        </tbody>
                      </table>



                           <table v-if="amarradores.length>0"  style="width: 100%; height: 100px; border: 1px solid #000000;">
                        <thead
                          style="background-color:gray; color:black; border: 1px solid #000000;"
                        >
                          <tr>
                            <th colspan="8">Amarradores</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr style="border: 1px solid #000000;">
                          
                            <td
                              id="texto"
                              style="border: 1px solid #000000;font-weight:bold; text-align:center"
                            >Folio de Factura</td>
                              <td
                              id="texto"
                              style="border: 1px solid #000000;font-weight:bold; text-align:center"
                            >Movimiento</td>
                            <td
                              id="texto"
                              style="border: 1px solid #000000;font-weight:bold; text-align:center"
                            >Fecha de Servicio</td>
                            <td
                              id="texto"
                             style="border: 1px solid #000000;font-weight:bold; text-align:center"
                            >Enlace</td>
                         
                          
                          </tr>
                          <tr v-for="(det) in amarradores" :key="det._id">
        
                          
                             <td
                              id="texto"
                              style="border: 1px solid #000000; color:#16db93;font-weight:bold;text-align:center"
                            >{{det.folioFactura}}</td>
                               <td
                              id="texto"
                              style="border: 1px solid #000000; color:#16db93;font-weight:bold;text-align:center"
                            >{{det.movimiento}}</td>
                                <td
                              id="texto"
                              style="border: 1px solid #000000; color:#16db93;font-weight:bold;text-align:center"
                            >{{det.fechaServicio}}</td>
                           <td
                              id="texto"
                              style="border: 1px solid #000000; color:#16db93;font-weight:bold;text-align:center"
                            ><a style="color:#16db93; font-weight:bold" :href="det.enlace" target="_blank">Enlace</a></td>
                          </tr>
                        </tbody>
                      </table><br>

                      <table  v-if="pilotosEnFalso.length>0" style="width: 100%; height: 100px;">
                        <thead style=" background-color:gray; color:black;">
                          <tr>
                            <th colspan="11">Pilotos En Falso</th>
                          </tr>
                        </thead>
                  
                        <tbody v-for="(det) in pilotosEnFalso" :key="det._id">
                           <tr>
                              <th style="color:black">Tiempo Piloto Falso</th>
                              <td style="color:#7400b8; font-weight:bold">{{det.tiempoPilotoFalso}}</td>
                              <th style="color:black">Piloto</th>
                              <td style="color:#7400b8; font-weight:bold">{{det.pilotoFalso}}</td>
                              <th style="color:black">Enlace</th>
                              <td style="color:#7400b8; font-weight:bold"><a style="color:#7400b8; font-weight:bold" :href="det.enlacePilotoFacturaFalso" target="_blank">{{det.noFacturaPilotoFalso}}</a></td>
                            </tr>
                           <tr>
                              <th style="color:black">Tiempo Lanchaje Falso</th>
                              <td style="color:#7400b8; font-weight:bold">{{det.tiempoLanchajeFalso}}</td>
                                <th style="color:black">Lanchaje</th>
                              <td style="color:#7400b8; font-weight:bold">{{det.lanchajeFalso}}</td>
                           
                              <th style="color:black">Enlace a Factura</th>
                              <td style="color:#7400b8; font-weight:bold"><a style="color:#7400b8; font-weight:bold" :href="det.enlaceLanchajeFacturaFalso" target="_blank">{{det.noFacturaLanchajeFalso}}</a></td>
                            </tr>
                          
                        </tbody>

                      </table>
                      <br>

                      
                      <table  v-if="remolcadores.length>0" style="width: 100%; height: 100px;">
                        <thead style=" background-color:gray; color:black;">
                          <tr>
                            <th colspan="11">Remolcadores</th>
                          </tr>
                        </thead>
                  
                        <tbody v-for="(det) in remolcadores" :key="det._id">
                           <tr>
                              <th style="color:black">Piloto</th>
                              <td style="color:#98c1d9; font-weight:bold">{{det.pilotoRemolcadores}}</td>
                              <th style="color:black">Folio Piloto</th>
                              <td style="color:#98c1d9; font-weight:bold">{{det.noFacturaRemolcadoresPiloto}}</td>
                              <th style="color:black">Enlace</th>
                              <td style="color:#98c1d9; font-weight:bold"><a style="color:#98c1d9; font-weight:bold" :href="det.enlaceFacturaPiloto" target="_blank">{{det.enlaceFacturaPiloto}}</a></td>
                            </tr>
                           <tr>
                              <th style="color:black">Lanchaje</th>
                              <td style="color:#98c1d9; font-weight:bold">{{det.lanchajeRemolcadores}}</td>
                                <th style="color:black">Folio Lanchaje</th>
                              <td style="color:#98c1d9; font-weight:bold">{{det.noFacturaRemolcadoresLanchaje}}</td>
                           
                              <th style="color:black">Enlace a Factura</th>
                              <td style="color:#98c1d9; font-weight:bold"><a style="color:#98c1d9; font-weight:bold" :href="det.enlaceFacturaLanchaje" target="_blank">{{det.enlaceFacturaLanchaje}}</a></td>
                            </tr>
                              <tr>
                              <th style="color:black">Fecha de Servicio</th>
                              <td style="color:#98c1d9; font-weight:bold">{{det.fechaServicioRemolcadores}}</td>
                                <th style="color:black">Folio Generador</th>
                              <td style="color:#98c1d9; font-weight:bold">{{det.noGeneradorRemolcadores}}</td>
                           
                              <th style="color:black">Enlace a Generador</th>
                              <td style="color:#98c1d9; font-weight:bold"><a style="color:#98c1d9; font-weight:bold" :href="det.enlaceFacturaRemolcador" target="_blank">{{det.enlaceFacturaRemolcador}}</a></td>
                            </tr>
                          
                        </tbody>

                      </table>
                      <br>


                    </div>
                  </div>
                  <div v-if="estado==4">
                   <h5> {{recoleccionDeInformacion}}</h5>
                   <h5> {{tiempoEnQueSeReviso}}</h5>
                   <h5> {{tiempoEnQueSeCotizo}}</h5>
                   <h5> {{tiempoEnQueSeEstimo}}</h5>
                   <h5> {{tiempoEnQueSeFacturo}}</h5>
                  </div>
              </v-card-text>
              <v-card-actions>
              </v-card-actions>
            </v-card>

          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.action="{ item }">

      <v-btn
         v-if="item.estado==0 || item.estado==1"
         color="orange"
         fab
         dark
         small
         @click="editItem(item)"
     >
     <v-icon>edit</v-icon>
     </v-btn>

    <v-btn
         v-if="item.estado==0 || item.estado ==1 || item.estado==2 || item.estado==3 || item.estado==4 || item.estado==5" 
         color="black"
         fab
         dark
         small
         @click="mostrarComprobante(item)"
     >
     <v-icon>assignment</v-icon>
     </v-btn>
    
    <v-btn
         v-if="item.estado==0"
         color="success"
         fab
         dark
         small
         @click="mostrarDialogoListo(item)"
     >
     <v-icon>check</v-icon>
  </v-btn>

   <v-btn
         v-if="item.estado==1"
         color="purple"
         fab
         dark
         small
         @click="mostrarDialogoRevisado(item)"
     >
     <v-icon>check</v-icon>
  </v-btn>

    <v-btn
         v-if="item.estado==2"
         color="green"
         fab
         dark
         small
         @click="mostrarDialogoCotizado(item)"
     >
     <v-icon>verified</v-icon>
  </v-btn>
    <v-btn
         v-if="item.estado==3"
         color="blue"
         fab
         dark
         small
         @click="mostrarDialogoEstimado(item)"
     >
     <v-icon>verified</v-icon>
  </v-btn>
     <v-btn
         v-if="item.estado==4"
         color="red"
         fab
         dark
         small
         @click="mostrarDialogoFacturado(item)"
     >
     <v-icon>verified</v-icon>
  </v-btn>
  


    


    


   

  




      </template>
        <template v-slot:item.arribo="{ item }">
          {{  item.arribo | moment("dddd Do MMMM YYYY")}}
      </template>
      
          <template v-slot:item.zarpe="{ item }">
          {{  item.zarpe | moment("dddd Do MMMM YYYY")}}
      </template>

    

     <v-dialog
      v-model="dialogCotizacion"
      persistent
      max-width="500px"
    >
    
      <v-card>
        <v-card-title>
          <span class="text-h5">Información Validada</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
               <v-col
                cols="12"
                sm="12"
                md="12"
              >
               <h4>El estatus del registro pasará a estimado y empezará el timer para el proceso de facturación</h4>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="12"
              >
                <v-text-field
                  label="Ingresa el folio de la estimación"
                  v-model="folioEstimacion"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            text
            @click="cancelarDialog()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="estimado(item)"
          >
            De acuerdo
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

      

     
   
  
      
      <template v-slot:no-data>
        <v-btn color="primary" @click="listar()">Resetear</v-btn>
      </template>
    </v-data-table>

    <v-container grid-list-sm class="pa-4 white" v-if="verNuevo">
        <v-layout row wrap>

           <v-flex xs11 sm11 lg11 x11>
              <div>
              

                <v-expansion-panels
                  v-model="panel"
                  multiple
                >
                 


                  <v-expansion-panel >
                    <v-expansion-panel-header  style="color:#390099; font-weight:bold">Informacion</v-expansion-panel-header>
                    <v-expansion-panel-content>
                           
                        <v-row>
                            <v-col cols="4" v-if="estado!==1">
                                  <v-autocomplete prepend-icon="directions_boat" v-on:change="mostrarDetallesDeEmbarcacion()" label="Embarcacion" v-model="embarcacion" dense outlined :items="embarcaciones"  ></v-autocomplete>
                            </v-col>
                              <v-col cols="4"  v-if="estado===1">
                                  <v-autocomplete prepend-icon="directions_boat" disabled v-on:change="mostrarDetallesDeEmbarcacion()" label="Embarcacion" v-model="embarcacion" dense outlined :items="embarcaciones"  ></v-autocomplete>
                            </v-col>
                            
                            <v-col cols="4" v-if="estado!=1">
                                  <v-autocomplete prepend-icon="face" label="Cliente" dense outlined v-model="cliente" :items="clientes" ></v-autocomplete>
                            </v-col>
                             <v-col cols="4" v-if="estado===1">
                                  <v-autocomplete prepend-icon="face" disabled label="Cliente" dense outlined v-model="cliente"  ></v-autocomplete>
                            </v-col>
                              <v-col cols="4" v-if="estado!=1">
                            <v-select v-on:change="modificarSwitch()" style="font-size:11px" v-model="puerto" dense prepend-icon="grid_4x4" label="Puerto" outlined
                                :items="['Seybaplaya','Ciudad del Carmen','Frontera','Chiltepec', 'Dos Bocas']"
                            ></v-select>                        
                            </v-col>
                             <v-col cols="4" v-if="estado===1">
                            <v-select v-on:change="modificarSwitch()" disabled style="font-size:11px" v-model="puerto" dense prepend-icon="grid_4x4" label="Puerto" outlined
                                :items="['Seybaplaya','Ciudad del Carmen','Frontera','Chiltepec', 'Dos Bocas']"
                            ></v-select>                        
                            </v-col>
                            
                             <v-col cols="12" v-if="estado!=1">
                              <v-text-field dense prepend-icon="timeline" label="Programa" outlined v-model="programa"   ></v-text-field>
                            </v-col>
                             <v-col cols="12" v-if="estado===1">
                              <v-text-field dense prepend-icon="timeline" disabled label="Programa" outlined v-model="programa"   ></v-text-field>
                            </v-col>
                             <v-col cols="3" v-if="estado!=1">
                                <v-switch v-model="serviciosCapitania" v-on:change="actualizarCapitania()" inset class="switch" label="¿Incluye servicios de Capitania?"   color="#ff0054"  hide-details></v-switch>  
                            </v-col>
                            <v-col cols="3" v-if="estado===1">
                                <v-switch v-model="serviciosCapitania" disabled v-on:change="actualizarCapitania()" inset class="switch" label="¿Incluye servicios de Capitania?"   color="#ff0054"  hide-details></v-switch>  
                            </v-col>
                             <v-col cols="3" v-if="estado!=1">
                                <v-switch class="switch" v-on:change="actualizarServiciosEnmienda()" inset v-if="parseInt(datosEmbarcacion.tbr) >= 500 && (puerto=='Seybaplaya' || puerto=='Frontera' || puerto=='Dos Bocas') || estado!=1" v-model="serviciosEnmiendas" label="¿Incluye servicios de Enmienda?"    color="#ffbd00"  hide-details></v-switch>  
                            </v-col>
                               <v-col cols="3" v-if="estado===1">
                                <v-switch class="switch" disabled v-on:change="actualizarServiciosEnmienda()" inset v-if="parseInt(datosEmbarcacion.tbr) >= 500 && (puerto=='Seybaplaya' || puerto=='Frontera' || puerto=='Dos Bocas') || estado!=1" v-model="serviciosEnmiendas" label="¿Incluye servicios de Enmienda?"    color="#ffbd00"  hide-details></v-switch>  
                            </v-col>
                            <v-col cols="3" v-if="estado!=1">
                                <v-switch class="switch"  v-on:change="actualizarServiciosAmarradores()"  inset v-if="parseInt(datosEmbarcacion.tbr) >= 500 && (puerto=='Dos Bocas' || puerto=='Chiltepec')" v-model="serviciosAmarradores" label="¿Incluye servicios de Amarradores?"  color="#16db93"  hide-details></v-switch>  
                            </v-col>
                             <v-col cols="3" v-if="estado===1">
                                <v-switch class="switch" disabled v-on:change="actualizarServiciosAmarradores()"  inset v-if="parseInt(datosEmbarcacion.tbr) >= 500 && (puerto=='Dos Bocas' || puerto=='Chiltepec')" v-model="serviciosAmarradores" label="¿Incluye servicios de Amarradores?"  color="#16db93"  hide-details></v-switch>  
                            </v-col>
                           
                          
                            
                             <v-col cols="3" v-if="estado!=1">
                                <v-switch class="switch" v-on:change="actualizarPilotosFalso()" inset v-if="parseInt(datosEmbarcacion.tbr) >= 500 && (puerto=='Dos Bocas' || puerto=='Seybaplaya' || puerto=='Ciudad del Carmen' || puerto=='Frontera')" v-model="pilotoFalso" label="¿Incluye Pilotos en Falso?"  color="#7400b8"  hide-details></v-switch>  
                            </v-col>
                              <v-col cols="3" v-if="estado===1">
                                <v-switch class="switch" disabled v-on:change="actualizarPilotosFalso()" inset v-if="parseInt(datosEmbarcacion.tbr) >= 500 && (puerto=='Dos Bocas' || puerto=='Seybaplaya' || puerto=='Ciudad del Carmen' || puerto=='Frontera')" v-model="pilotoFalso" label="¿Incluye Pilotos en Falso?"  color="#7400b8"  hide-details></v-switch>  
                            </v-col>
                          
                        </v-row>
                         
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header style="color:#9e0059; font-weight:bold">Movimientos</v-expansion-panel-header>
                    <v-expansion-panel-content>
                    <h5 style="color:#31467C">Entrada</h5>
                        <v-row>
                           
                          
                        <v-col cols="6" sm="6" md="6" v-if="estado!=1">
                            <v-datetime-picker  label='Arribo'  v-model="movimientoEntradaArribo" > </v-datetime-picker>   
                        </v-col>
                          <v-col cols="6" sm="6" md="6" v-if="estado===1">
                            <v-datetime-picker disabled label='Arribo'  v-model="movimientoEntradaArribo" > </v-datetime-picker>   
                        </v-col>

                            <v-col cols="6" sm="6" md="6" v-if="estado!=1">
                                <v-datetime-picker  label='Atraque'  v-model="movimientoEntradaAtraque" > </v-datetime-picker>   
                            </v-col>
                              <v-col cols="6" sm="6" md="6" v-if="estado===1">
                                <v-datetime-picker disabled label='Atraque'  v-model="movimientoEntradaAtraque" > </v-datetime-picker>   
                            </v-col>
                        </v-row>

                    <h5 style="color:#31467C">Salida</h5>
                        <v-row>
                           
                            <v-col cols="6" sm="6" md="6" v-if="estado!=1">
                                <v-datetime-picker label='Zarpe'  v-model="movimientoSalidaZarpe" > </v-datetime-picker> 
                            </v-col>
                             <v-col cols="6" sm="6" md="6" v-if="estado===1">
                                <v-datetime-picker disabled label='Zarpe'  v-model="movimientoSalidaZarpe" > </v-datetime-picker> 
                            </v-col>

                             <v-col cols="6" sm="6" md="6" v-if="estado!=1">
                                 <v-datetime-picker label='Desatraque'  v-model="movimientoSalidaDesatraque" > </v-datetime-picker> 
                             
                            </v-col>
                                <v-col cols="6" sm="6" md="6" v-if="estado===1">
                                 <v-datetime-picker disabled label='Desatraque'  v-model="movimientoSalidaDesatraque" > </v-datetime-picker> 
                             
                            </v-col>

                           
                           
                            
                        </v-row>

                      
                           
                           
                       
                          
                         
                  
                         
                    </v-expansion-panel-content>
                        </v-expansion-panel>

                    <v-expansion-panel v-if="parseInt(datosEmbarcacion.tbr) >= 500 && (puerto!='Chiltepec')">
                    <v-expansion-panel-header   style="color:#ff5400; font-weight:bold">Pilotos y Lanchaje</v-expansion-panel-header>
                    <v-expansion-panel-content >
                       

                      
                      <v-row>
                        <v-col col="6">
                            <h5 style="color:#31467C">Piloto Entrada</h5>
                        </v-col>
                      
                      </v-row>
                        <v-row>
                             <v-col cols="5" v-if="estado!=1">
                              <v-select v-if="puerto=='Dos Bocas'" style="font-size:15px"
                                :items="['Francisco Matías Vázquez Gutiérrez','Piloto Sindicato','Francisco Javier Elizalde Olguín']"
                                label="Entidad" v-model="pilotoEntradaEntidad"
                            ></v-select>
                             <v-text-field v-else v-model="pilotoEntradaEntidad" style="font-size:15px" disabled ></v-text-field>
                            
                            </v-col>
                              <v-col cols="5" v-if="estado===1">
                              <v-select disabled v-if="puerto=='Dos Bocas'" style="font-size:15px"
                                :items="['Francisco Matías Vázquez Gutiérrez','Piloto Sindicato','Francisco Javier Elizalde Olguín']"
                                label="Entidad" v-model="pilotoEntradaEntidad"
                            ></v-select>
                             <v-text-field disabled v-else v-model="pilotoEntradaEntidad" style="font-size:15px" disabled ></v-text-field>
                            
                            </v-col>
                             <v-col cols="3" v-if="estado!=1">
                              <v-text-field v-model="pilotoEntradaTiempo" label="Tiempo"></v-text-field>
                            </v-col>
                              <v-col cols="3" v-if="estado===1">
                              <v-text-field disabled v-model="pilotoEntradaTiempo" label="Tiempo"></v-text-field>
                            </v-col>
                             <v-col cols="4" v-if="estado===1">
                              <v-text-field  v-model="pilotoEntradaFactura" label="No de Factura"></v-text-field>
                            </v-col>
                              <v-col cols="4" v-if="estado!=1">
                              <v-text-field disabled v-model="pilotoEntradaFactura" label="No de Factura"></v-text-field>
                            </v-col>
                            <v-col cols="12" v-if="estado===1">
                           <v-text-field label="Enlace"   v-model="pilotoEntradaEnlace"></v-text-field>
                            </v-col>
                             <v-col cols="12" v-if="estado!=1">
                           <v-text-field label="Enlace"  disabled v-model="pilotoEntradaEnlace"></v-text-field>
                            </v-col>
                              
                          
                           
                        </v-row>


                      <v-row>
                        
                        <v-col col="6">
                            <h5 style="color:#31467C">Piloto Salida</h5>
                        </v-col>            
                      
                      </v-row>
                        <v-row>
                           
                             <v-col cols="5" v-if="estado!=1">
                              <v-select v-if="puerto=='Dos Bocas'" style="font-size:15px"
                                :items="['Francisco Matías Vázquez Gutiérrez','Piloto Sindicato','Francisco Javier Elizalde Olguín']"
                                label="Entidad" v-model="pilotoSalidaEntidad"
                            ></v-select>
                             <v-text-field v-else v-model="pilotoSalidaEntidad" style="font-size:15px" disabled class="inputPequeño"></v-text-field>
                           
                            </v-col>
                               <v-col cols="5" v-if="estado==1">
                              <v-select disabled v-if="puerto=='Dos Bocas'" style="font-size:15px"
                                :items="['Francisco Matías Vázquez Gutiérrez','Piloto Sindicato','Francisco Javier Elizalde Olguín']"
                                label="Entidad" v-model="pilotoSalidaEntidad"
                            ></v-select>
                             <v-text-field v-else v-model="pilotoSalidaEntidad" style="font-size:15px" disabled class="inputPequeño"></v-text-field>
                           
                            </v-col>
                             <v-col cols="3" v-if="estado!=1">
                              <v-text-field v-model="pilotoSalidaTiempo"  label="Tiempo"></v-text-field>
                            </v-col>
                             <v-col cols="3" v-if="estado===1">
                              <v-text-field disabled v-model="pilotoSalidaTiempo"  label="Tiempo"></v-text-field>
                            </v-col>
                              <v-col cols="4" v-if="estado===1">
                              <v-text-field  v-model="pilotoSalidaFactura" label="No de Factura"></v-text-field>
                            </v-col>
                              <v-col cols="4" v-if="estado!=1">
                              <v-text-field disabled v-model="pilotoSalidaFactura" label="No de Factura"></v-text-field>
                            </v-col>
                            <v-col cols="12" v-if="estado===1">
                           <v-text-field label="Enlace"   v-model="pilotoSalidaEnlace"></v-text-field>
                            </v-col>
                             <v-col cols="12" v-if="estado!=1">
                           <v-text-field label="Enlace"  disabled v-model="pilotoSalidaEnlace"></v-text-field>
                            </v-col>

                          
                           
                         </v-row>
                          <h5 style="color:#66B6BC">Lanchaje Entrada</h5>
                        <v-row>

                            <v-col cols="5" v-if="estado!=1">
                            <v-select v-if="puerto=='Dos Bocas'" style="font-size:15px" v-model="lanchajeEntradaEntidad"
                                :items="['Maya Maritima del Sureste','Asesores Profesionales en Transportación','Sistemas Inteligentes de Puebla','Transportación Maritima Portuaria Dos Bocas']"
                            ></v-select>
                              <v-text-field v-else v-model="lanchajeEntradaEntidad" style="font-size:15px" disabled class="inputPequeño"  ></v-text-field>
                             
                            </v-col>
                            <v-col cols="5" v-if="estado===1">
                            <v-select disabled v-if="puerto=='Dos Bocas'" style="font-size:15px" v-model="lanchajeEntradaEntidad"
                                :items="['Maya Maritima del Sureste','Asesores Profesionales en Transportación','Sistemas Inteligentes de Puebla','Transportación Maritima Portuaria Dos Bocas']"
                            ></v-select>
                              <v-text-field v-else v-model="lanchajeEntradaEntidad" style="font-size:15px" disabled class="inputPequeño"  ></v-text-field>
                            </v-col>
                             <v-col cols="3" v-if="estado!=1">
                              <v-text-field v-model="lanchajeEntradaTiempo" label="Tiempo"></v-text-field>
                            </v-col>
                              <v-col cols="3" v-if="estado===1">
                              <v-text-field disabled v-model="lanchajeEntradaTiempo" label="Tiempo"></v-text-field>
                            </v-col>
                                <v-col cols="4" v-if="estado!=1">
                              <v-text-field v-model="lanchajeEntradaNoFactura" disabled label="No de Factura"></v-text-field>
                            </v-col>
                             <v-col cols="4" v-if="estado===1">
                              <v-text-field  v-model="lanchajeEntradaNoFactura"  label="No de Factura"></v-text-field>
                            </v-col>
                           
                              <v-col cols="12" v-if="estado!=1" >
                           <v-text-field label="Enlace" disabled v-model="lanchajeEntradaEnlace" ></v-text-field>
                        </v-col>
                          <v-col cols="12" v-if="estado===1" >
                           <v-text-field label="Enlace"  v-model="lanchajeEntradaEnlace" ></v-text-field>
                        </v-col>

                        </v-row>
                          <h5 style="color:#66B6BC">Lanchaje Salida</h5>
                        <v-row>
                           
                           
                             <v-col cols="5" v-if="estado!=1">
                            <v-select v-if="puerto=='Dos Bocas'" style="font-size:15px" v-model="lanchajeSalidaEntidad"
                                :items="['Maya Maritima del Sureste','Asesores Profesionales en Transportación','Sistemas Inteligentes de Puebla','Transportación Maritima Portuaria Dos Bocas']"
                            ></v-select>
                              <v-text-field v-else v-model="lanchajeSalidaEntidad" style="font-size:15px" disabled class="inputPequeño"></v-text-field>
                            </v-col>
                             <v-col cols="5" v-if="estado===1">
                            <v-select disabled v-if="puerto=='Dos Bocas'" style="font-size:15px" v-model="lanchajeSalidaEntidad"
                                :items="['Maya Maritima del Sureste','Asesores Profesionales en Transportación','Sistemas Inteligentes de Puebla','Transportación Maritima Portuaria Dos Bocas']"
                            ></v-select>
                              <v-text-field v-else v-model="lanchajeSalidaEntidad" style="font-size:15px" disabled class="inputPequeño"></v-text-field>
                            </v-col>
                             <v-col cols="3" v-if="estado!=1">
                              <v-text-field v-model="lanchajeSalidaTiempo" label="Tiempo"></v-text-field>
                            </v-col>
                            <v-col cols="3" v-if="estado===1">
                              <v-text-field disabled v-model="lanchajeSalidaTiempo" label="Tiempo"></v-text-field>
                            </v-col>
                            <v-col cols="4" v-if="estado!=1">
                              <v-text-field v-model="lanchajeSalidaNoFactura" disabled label="No de Factura"></v-text-field>
                            </v-col>
                             <v-col cols="4" v-if="estado===1">
                              <v-text-field v-model="lanchajeSalidaNoFactura"  label="No de Factura"></v-text-field>
                            </v-col>
                           
                              <v-col cols="12" v-if="estado!=1">
                           <v-text-field v-model="lanchajeSalidaEnlace" disabled label="Enlace"  ></v-text-field>
                        </v-col>
                         <v-col cols="12" v-if="estado===1">
                           <v-text-field  v-model="lanchajeSalidaEnlace" label="Enlace"  ></v-text-field>
                        </v-col>
                        </v-row>
                       
                        
                          
                         
                  
                         
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                    <v-expansion-panel v-if="serviciosCapitania==true">
                    <v-expansion-panel-header style="color:#ff0054; font-weight:bold">Capitania</v-expansion-panel-header>
                    <v-expansion-panel-content>
                       

                     <v-row no-gutters>
                                <v-col cols="3">
                                   <h5 style="color:#31467C;" >Secretaria de Marina</h5>
                                </v-col >
                                <v-col cols=4 v-if="estado!=1">
                                   <v-btn small fab dar color="" @click="agregarCapitania()">
                                            <v-icon dark>engineering
                                        </v-icon>
                                    </v-btn>
                                </v-col>
                                  <v-col cols=4 v-if="estado===1">
                                   <v-btn disabled small fab dar color="" @click="agregarCapitania()">
                                            <v-icon dark>engineering
                                        </v-icon>
                                    </v-btn>
                                </v-col>
                               <v-row v-for="item in capitania" :key="item._id">
                                
                                  <v-col cols="2" v-if="estado!=1">
                                    <v-text-field label="No. Hoja de Ayuda"  v-model="item.noHojaAyuda"  outlined dense></v-text-field>
                                  </v-col>
                                    <v-col cols="2" v-if="estado===1">
                                    <v-text-field disabled label="No. Hoja de Ayuda"  v-model="item.noHojaAyuda"  outlined dense></v-text-field>
                                  </v-col>
                              
                                   <v-col cols="3" v-if="estado!=1">
                                    <v-select
                                      :items="['Despacho','Enmienda','Fondeo','Arribo']"
                                      label="Tipo de Servicio"
                                      outlined dense
                                      v-model="item.tipoServicio"
                                  ></v-select>
                                   </v-col>
                                   
                                    <v-col cols="3" v-if="estado===1">
                                    <v-select
                                    disabled
                                      :items="['Despacho','Enmienda','Fondeo','Arribo']"
                                      label="Tipo de Servicio"
                                      outlined dense
                                      v-model="item.tipoServicio"
                                  ></v-select>
                                   </v-col>
                                
                                 
                                 
                                    <v-col cols="7" v-if="estado!=1">
                                    <v-text-field label="Enlace Hoja de Ayuda" v-model="item.enlaceHojaAyudaCapitania" prepend-icon="cloud_upload" dense></v-text-field>
                                  </v-col>
                                    <v-col cols="7" v-if="estado===1">
                                    <v-text-field label="Enlace Hoja de Ayuda" disabled v-model="item.enlaceHojaAyudaCapitania" prepend-icon="cloud_upload" dense></v-text-field>
                                  </v-col>

                                    
                                  <v-col cols="2" v-if="estado!=1">
                                    <v-text-field label="No. Factura" disabled  v-model="item.noFactura"  outlined dense></v-text-field>
                                  </v-col>
                                    <v-col cols="2" v-if="estado===1">
                                    <v-text-field  label="No. Factura"  v-model="item.noFactura"  outlined dense></v-text-field>
                                  </v-col>

                                    <v-col cols="10" v-if="estado!=1">
                                    <v-text-field label="Enlace a factura" disabled v-model="item.enlaceFacturaCapitania" prepend-icon="cloud_upload" dense></v-text-field>
                                  </v-col>
                                    <v-col cols="10" v-if="estado===1">
                                    <v-text-field label="Enlace a factura"  v-model="item.enlaceFacturaCapitania" prepend-icon="cloud_upload" dense></v-text-field>
                                  </v-col>
                                 
                                    
                                  <v-col cols="2" v-if="estado!=1">
                                    <v-btn small color="red" class="ma-2 white--text" @click="eliminarAmarradores(capitania,item)">Eliminar<v-icon right dark>
                                      delete
                                    </v-icon>
                                  </v-btn>
                                 </v-col>
                                  <v-col cols="2" v-if="estado===1">
                                    <v-btn small color="red" disabled class="ma-2 white--text" @click="eliminarAmarradores(capitania,item)">Eliminar<v-icon right dark>
                                      delete
                                    </v-icon>
                                  </v-btn>
                                 </v-col>
                                </v-row>   
                           
                         </v-row>   
                    </v-expansion-panel-content>
                    
                  </v-expansion-panel>

                  
                    <v-expansion-panel>
                    <v-expansion-panel-header style="color:#2c699a; font-weight:bold">API</v-expansion-panel-header>
                    <v-expansion-panel-content>
                       

                     <v-row no-gutters>
                             
                                <v-col cols=4 v-if="estado!=1">
                                   <v-btn small fab dar color="" @click="agregarApi()">
                                            <v-icon dark>engineering
                                        </v-icon>
                                    </v-btn>
                                </v-col>
                                  <v-col cols=4 v-if="estado===1">
                                   <v-btn disabled small fab dar color="" @click="agregarApi()">
                                            <v-icon dark>engineering
                                        </v-icon>
                                    </v-btn>
                                </v-col>
                              </v-row> 
                              
                               <v-row v-for="item in adminApi" :key="item.id">
                                
                                    <v-col cols="5" v-if="estado!=1">
                                      <v-text-field label="Administración Portuaria Integral" value="Administración Portuaria Integral" disabled solo dense></v-text-field>
                                    </v-col>  
                                    <v-col cols="5" v-if="estado===1">
                                      <v-text-field  disabled label="Administración Portuaria Integral" value="Administración Portuaria Integral"  solo dense></v-text-field>
                                    </v-col>                              
                                    <v-col cols="3" v-if="estado!=1">
                                      <v-text-field label="Fecha de Servicio" outlined  v-model="item.fechaServicio" dense></v-text-field>
                                    </v-col>
                                      <v-col cols="3" v-if="estado===1">
                                      <v-text-field label="Fecha de Servicio" disabled outlined  v-model="item.fechaServicio" dense></v-text-field>
                                    </v-col>
                                     <v-col cols="4" v-if="estado!=1">
                                      <v-text-field label="Movimiento" outlined  v-model="item.movimientoApi" dense></v-text-field>
                                    </v-col>
                                     <v-col cols="4" v-if="estado===1">
                                      <v-text-field label="Movimiento" outlined disabled  v-model="item.movimientoApi" dense></v-text-field>
                                    </v-col>
                                    <v-col cols="3" v-if="estado!=1">
                                      <v-text-field label="No Factura" outlined disabled  v-model="item.noFactura" dense></v-text-field>
                                    </v-col>
                                     <v-col cols="3" v-if="estado===1">
                                      <v-text-field label="No Factura" outlined   v-model="item.noFactura" dense></v-text-field>
                                    </v-col>
                                     <v-col cols="7" v-if="estado!=1">
                                      <v-text-field label="Enlace Factura" outlined disabled  v-model="item.enlaceFactura" dense></v-text-field>
                                    </v-col>
                                     <v-col cols="7" v-if="estado===1">
                                      <v-text-field label="Enlace Factura" outlined   v-model="item.enlaceFactura" dense></v-text-field>
                                    </v-col>
                                      <v-col cols="2" v-if="estado!=1">
                                          <v-btn small color="red" class="ma-2 white--text" @click="eliminarAmarradores(adminApi,item)">Eliminar<v-icon right dark>
                                            delete
                                          </v-icon>
                                        </v-btn>
                                      </v-col>
                                        <v-col cols="2" v-if="estado===1">
                                          <v-btn small color="red" disabled class="ma-2 white--text" @click="eliminarAmarradores(adminApi,item)">Eliminar<v-icon right dark>
                                            delete
                                          </v-icon>
                                        </v-btn>
                                      </v-col>
                                </v-row>   
                           
                           
                    </v-expansion-panel-content>
                    
                  </v-expansion-panel>


                    <v-expansion-panel v-if="serviciosEnmiendas==true && datosEmbarcacion.tbr>=500">
                    <v-expansion-panel-header  style="color:#ffbd00; font-wight:bold">Enmiendas</v-expansion-panel-header>
                    <v-expansion-panel-content>
                              <v-row no-gutters >
                                <v-col cols="12" class="text--secondary" v-if="estado!=1">
                                   <v-flex xs3 sm3 md3 lg3 x3>
                                        <v-btn small fab dar color="" @click="agregarPiloto()">
                                            <v-icon dark>group_add
                                        </v-icon>
                                        </v-btn>
                                         <v-btn small fab dar color="" @click="agregarLanchaje()">
                                            <v-icon dark>sailing
                                        </v-icon>
                                        </v-btn>    
                                    </v-flex>
                                </v-col>  
                                <v-col v-if="estado===1" cols="12" class="text--secondary">
                                   <v-flex xs3 sm3 md3 lg3 x3>
                                        <v-btn disabled small fab dar color="" @click="agregarPiloto()">
                                            <v-icon dark>group_add
                                        </v-icon>
                                        </v-btn>
                                         <v-btn disabled small fab dar color="" @click="agregarLanchaje()">
                                            <v-icon dark>sailing
                                        </v-icon>
                                        </v-btn>    
                                    </v-flex>
                                </v-col>  

                                     <v-row v-for="item in enmiendaPilotos" :key="item.id">
                                        <v-col cols="4" v-if="estado!=1">
                                          <v-datetime-picker  class="pa-0" hide-details label="Fecha" v-model="item.fechaHoraPilotoEnmienda" > </v-datetime-picker>
                                         </v-col>
                                        <v-col cols="4" v-if="estado===1">
                                          <v-datetime-picker  class="pa-0" hide-details disabled label="Fecha" v-model="item.fechaHoraPilotoEnmienda" > </v-datetime-picker>
                                        </v-col>
                                         <v-col cols="4" v-if="estado!=1">
                                           <v-text-field label="Movimiento" outlined   v-model="item.movimientoPilotoEnmienda" dense></v-text-field>
                                         </v-col>
                                          <v-col cols="4" v-if="estado===1">
                                           <v-text-field label="Movimiento" outlined disabled  v-model="item.movimientoPilotoEnmienda" dense></v-text-field>
                                         </v-col>

                                         <v-col cols="4" v-if="estado!=1">
                                             <v-select v-if="puerto=='Dos Bocas'" style="font-size:11px"
                                                :items="['Francisco Matías Vázquez Gutiérrez','Piloto Sindicato','Francisco Javier Elizalde Olguín']"
                                                label="Entidad" v-model="item.PilotoEnmienda"
                                            ></v-select>
                                               <v-text-field v-else v-model="item.PilotoEnmienda" disabled style="font-size:14px" ></v-text-field>
                                         </v-col>
                                          <v-col cols="4" v-if="estado===1">
                                              <v-select disabled v-if="puerto=='Dos Bocas'" style="font-size:11px"
                                                :items="['Francisco Matías Vázquez Gutiérrez','Piloto Sindicato','Francisco Javier Elizalde Olguín']"
                                                label="Entidad" v-model="item.PilotoEnmienda"
                                            ></v-select>
                                            <v-text-field v-else v-model="item.PilotoEnmienda" disabled style="font-size:14px" ></v-text-field>
                                         </v-col>
                                          <v-col cols="11" v-if="estado!=1">
                                           <v-text-field label="Enlace a Factura" disabled outlined   v-model="item.enlacePilotoEnmienda" dense></v-text-field>
                                         </v-col>
                                          <v-col cols="11" v-if="estado===1">
                                           <v-text-field label="Enlace a Factura" outlined   v-model="item.enlacePilotoEnmienda" dense></v-text-field>
                                         </v-col>
                                           <v-col cols="1" v-if="estado!=1">
                                               <v-icon
                                                  small
                                                  @click="eliminarPasajero(enmiendaPilotos,item)"
                                                  >
                                                  delete
                                              </v-icon>
                                         </v-col>
                                          <v-col cols="1" v-if="estado===1">
                                              <v-icon
                                                  disabled
                                                  small
                                                  @click="eliminarPasajero(enmiendaPilotos,item)"
                                                  >
                                                  delete
                                              </v-icon>
                                         </v-col>
                                       
                                     </v-row>

                                     <v-row v-for="item in enmiendaLanchaje" :key="item.id">
                                        <v-col cols="4" v-if="estado!=1">
                                          <v-datetime-picker  class="pa-0" hide-details label="Fecha" v-model="item.fechaHoraLanchajeEnmienda" > </v-datetime-picker>
                                         </v-col>
                                        <v-col cols="4" v-if="estado===1">
                                          <v-datetime-picker  class="pa-0" hide-details disabled label="Fecha"  v-model="item.fechaHoraLanchajeEnmienda" > </v-datetime-picker>
                                        </v-col>
                                         <v-col cols="4" v-if="estado!=1">
                                           <v-text-field label="Movimiento" outlined   v-model="item.movimientoLanchajeEnmienda"  dense></v-text-field>
                                         </v-col>
                                          <v-col cols="4" v-if="estado===1">
                                           <v-text-field label="Movimiento" outlined disabled  v-model="item.movimientoLanchajeEnmienda" dense></v-text-field>
                                         </v-col>

                                         <v-col cols="4" v-if="estado!=1">
                                              <v-select v-if="puerto=='Dos Bocas'" style="font-size:11px" v-model="item.lanchajeEnmienda"
                                                  :items="['Maya Maritima del Sureste','Asesores Profesionales en Transportación','Sistemas Inteligentes de Puebla','Transportación Maritima Portuaria Dos Bocas']"
                                              ></v-select>
                                              <v-text-field v-else v-model="item.lanchajeEnmienda" disabled style="font-size:14px" ></v-text-field>
                                         </v-col>
                                          <v-col cols="4" v-if="estado===1">
                                               <v-select disabled v-if="puerto=='Dos Bocas'" style="font-size:11px" v-model="item.lanchajeEnmienda"
                                                    :items="['Maya Maritima del Sureste','Asesores Profesionales en Transportación','Sistemas Inteligentes de Puebla','Transportación Maritima Portuaria Dos Bocas']"
                                                ></v-select>
                                         <v-text-field v-else v-model="item.lanchajeEnmienda" disabled style="font-size:14px" ></v-text-field>
                                         </v-col>
                                          <v-col cols="11" v-if="estado!=1">
                                           <v-text-field label="Enlace a Factura" disabled outlined   v-model="item.enlanceLanchajeEnlace" dense></v-text-field>
                                         </v-col>
                                          <v-col cols="11" v-if="estado===1">
                                           <v-text-field label="Enlace a Factura" outlined   v-model="item.enlanceLanchajeEnlace" dense></v-text-field>
                                         </v-col>
                                           <v-col cols="1" v-if="estado!=1">
                                            <v-icon
                                                  small
                                                  @click="eliminarPasajero(enmiendaLanchaje,item)"
                                                  >
                                                  delete
                                              </v-icon>
                                       
                                             
                                         </v-col>
                                          <v-col cols="1" v-if="estado===1">
                                            <v-icon
                                                  disabled
                                                  small
                                                  @click="eliminarPasajero(enmiendaLanchaje,item)"
                                                  >
                                                  delete
                                              </v-icon>
                                         </v-col>
                                      
                                         
                                             
                                     
                                       
                                     </v-row>
                                  
                                        
                           
                         </v-row>
                         
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                    <v-expansion-panel v-if="serviciosAmarradores==true  && datosEmbarcacion.tbr>=500 ">
                    <v-expansion-panel-header  style="color:#16db93; font-wight:bold">Amarradores</v-expansion-panel-header>
                    <v-expansion-panel-content>
                              <v-row no-gutters>
                                <v-col cols="12" class="text--secondary" v-if="estado!=1">
                                   <v-flex xs12 sm2 md2 lg2 x12>
                                        <v-btn small fab dar color="" @click="agregarAmarrador()">
                                            <v-icon dark>gesture
                                        </v-icon>
                                        </v-btn>
                                    </v-flex>
                                </v-col>
                                 <v-col cols="12" class="text--secondary" v-if="estado===1">
                                   <v-flex xs12 sm2 md2 lg2 x12>
                                        <v-btn disabled small fab dar color="" @click="agregarAmarrador()">
                                            <v-icon dark>gesture
                                        </v-icon>
                                        </v-btn>
                                    </v-flex>
                                </v-col>
                                <v-row v-for="item in amarradores" :key="item.id">
                                  <v-col cols="4" v-if="estado!=1">
                                    <v-text-field label="Fecha de Servicio" outlined   v-model="item.fechaServicio" dense></v-text-field>
                                  </v-col>
                                  <v-col cols="4" v-if="estado===1">
                                    <v-text-field label="Fecha de Servicio" outlined  disabled v-model="item.fechaServicio" dense></v-text-field>
                                  </v-col>
                                    <v-col cols="4" v-if="estado!=1">
                                    <v-text-field label="Movimiento" outlined   v-model="item.movimiento" dense></v-text-field>
                                  </v-col>
                                  <v-col cols="4" v-if="estado===1">
                                    <v-text-field label="Movimiento" outlined disabled  v-model="item.movimiento" dense></v-text-field>
                                  </v-col>
                                    <v-col cols="4" v-if="estado!=1">
                                    <v-text-field label="Folio de Factura" outlined disabled  v-model="item.folioFactura" dense></v-text-field>
                                  </v-col>
                                  <v-col cols="4" v-if="estado===1">
                                    <v-text-field label="Folio de Factura" outlined   v-model="item.folioFactura" dense></v-text-field>
                                  </v-col>
                                   <v-col cols="10" v-if="estado!=1">
                                    <v-text-field label="Enlace de Factura" outlined disabled  v-model="item.enlace" dense></v-text-field>
                                  </v-col>
                                  <v-col cols="10" v-if="estado===1">
                                    <v-text-field label="Enlace de Factura" outlined   v-model="item.enlace" dense></v-text-field>
                                  </v-col>
                                  <v-col cols="2" v-if="estado!=1">
                                    <v-icon
                                     small
                                     @click="eliminarAmarradores(amarradores,item)"
                                      >
                                       delete
                                    </v-icon>
                                  </v-col>
                                   <v-col cols="2" v-if="estado===1">
                                    <v-icon
                                    disabled
                                     small
                                     @click="eliminarAmarradores(amarradores,item)"
                                      >
                                       delete
                                    </v-icon>
                                  </v-col>
                                   
                                </v-row>

                                

                           
                         </v-row>
                         
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                     <v-expansion-panel v-if="pilotoFalso==true">
                    <v-expansion-panel-header  style="color:#7400b8; font-weight:bold">Pilotos y Lanchaje en Falso</v-expansion-panel-header>
                    <v-expansion-panel-content>
                       

                     <v-row no-gutters>
                             
                                <v-col cols=4 v-if="estado!=1">
                                   <v-btn small fab dar color="" @click="agregarPilotoFalso()">
                                            <v-icon dark>engineering
                                        </v-icon>
                                    </v-btn>
                                </v-col>
                                 <v-col cols=4 v-if="estado===1">
                                   <v-btn small disabled fab dar color="" @click="agregarPilotoFalso()">
                                            <v-icon dark>engineering
                                        </v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                               <v-row v-for="item in pilotosFalso" :key="item._id">                              
                                      <v-col cols="5" v-if="estado!=1" >
                                        <v-select v-if="puerto=='Dos Bocas'" style="font-size:15"
                                            :items="['Francisco Matías Vázquez Gutiérrez','Piloto Sindicato','Francisco Javier Elizalde Olguín']"
                                            label="Entidad" v-model="item.pilotoFalso"
                                        ></v-select>
                                        <v-text-field v-else v-model="item.entidadPilotoFalso"   disabled class="inputPequeño" label="Piloto"></v-text-field>                                                 
                                      </v-col>
                                      <v-col cols="5" v-if="estado===1">
                                        <v-select disabled v-if="puerto=='Dos Bocas'" style="font-size:15"
                                            :items="['Francisco Matías Vázquez Gutiérrez','Piloto Sindicato','Francisco Javier Elizalde Olguín']"
                                            label="Entidad" v-model="item.pilotoFalso"
                                        ></v-select>
                                        <v-text-field v-else v-model="item.entidadPilotoFalso"   disabled class="inputPequeño" label="Piloto"></v-text-field>                                                 
                                      </v-col>
                                      <v-col cols="3" v-if="estado!=1">
                                          <v-text-field style="font-size:15" label="Tiempo Piloto" v-model="item.tiempoPilotoFalso"></v-text-field>
                                      </v-col>
                                      <v-col cols="3" v-if="estado===1">
                                          <v-text-field disabled style="font-size:15" label="Tiempo Piloto" v-model="item.tiempoPilotoFalso"></v-text-field>
                                      </v-col>
                                       <v-col cols="4" v-if="estado!=1">
                                          <v-text-field disabled style="font-size:15" label="No Factura" v-model="item.noFacturaPilotoFalso"></v-text-field>
                                      </v-col>
                                      <v-col cols="4" v-if="estado===1">
                                          <v-text-field  style="font-size:15" label="No Factura" v-model="item.noFacturaPilotoFalso"></v-text-field>
                                      </v-col>
                                        <v-col cols="12" v-if="estado!=1">
                                          <v-text-field disabled style="font-size:15" label="Enlace Factura" v-model="item.enlacePilotoFacturaFalso"></v-text-field>
                                      </v-col>
                                      <v-col cols="12" v-if="estado===1">
                                          <v-text-field  style="font-size:15" label="Enlace Factura" v-model="item.enlacePilotoFacturaFalso"></v-text-field>
                                      </v-col>                                                                
                                      <v-col cols="5" v-if="estado!=1">
                                        <v-select v-if="puerto=='Dos Bocas'" label="Entidad" style="font-size:15px" v-model="item.lanchajeFalso"
                                            :items="['Maya Maritima del Sureste','Asesores Profesionales en Transportación','Sistemas Inteligentes de Puebla','Transportación Maritima Portuaria Dos Bocas']"
                                        ></v-select>
                                        <v-text-field v-else v-model="item.entidadLanchajeFalso"  disabled class="inputPequeño" label="Lanchaje"></v-text-field>                   
                                      </v-col>
                                       <v-col cols="5" v-if="estado===1">
                                        <v-select disabled v-if="puerto=='Dos Bocas'" label="Entidad" style="font-size:15px" v-model="item.lanchajeFalso"
                                            :items="['Maya Maritima del Sureste','Asesores Profesionales en Transportación','Sistemas Inteligentes de Puebla','Transportación Maritima Portuaria Dos Bocas']"
                                        ></v-select>
                                        <v-text-field v-else v-model="item.entidadLanchajeFalso"  disabled class="inputPequeño" label="Lanchaje"></v-text-field>                   
                                      </v-col>
                                      <v-col cols="3" v-if="estado!=1">
                                          <v-text-field style="font-size:15px" label="Tiempo Lanchaje" v-model="item.tiempoLanchajeFalso"></v-text-field>
                                      </v-col>
                                        <v-col cols="3" v-if="estado===1">
                                          <v-text-field disabled style="font-size:15px" label="Tiempo Lanchaje" v-model="item.tiempoLanchajeFalso"></v-text-field>
                                      </v-col>
                                        <v-col cols="4" v-if="estado!=1">
                                          <v-text-field disabled style="font-size:15" label="No Factura" v-model="item.noFacturaLanchajeFalso"></v-text-field>
                                      </v-col>
                                      <v-col cols="4" v-if="estado===1">
                                          <v-text-field  style="font-size:15" label="No Factura" v-model="item.noFacturaLanchajeFalso"></v-text-field>
                                      </v-col>
                                        <v-col cols="12" v-if="estado!=1">
                                          <v-text-field disabled style="font-size:15" label="Enlace Factura" v-model="item.enlaceLanchajeFacturaFalso"></v-text-field>
                                      </v-col>
                                      <v-col cols="12" v-if="estado===1">
                                          <v-text-field  style="font-size:15" label="Enlace Factura" v-model="item.enlaceLanchajeFacturaFalso"></v-text-field>
                                      </v-col>  
                                      <v-col cols="2" v-if="estado!=1">
                                    <v-btn small color="red" class="ma-2 white--text" @click="eliminarAmarradores(pilotosFalso,item)">Eliminar<v-icon right dark>
                                      delete
                                    </v-icon>
                                  </v-btn>
                                 </v-col>
                                   <v-col cols="2" v-if="estado===1">
                                    <v-btn small disabled color="red" class="ma-2 white--text" @click="eliminarAmarradores(pilotosFalso,item)">Eliminar<v-icon right dark>
                                      delete
                                    </v-icon>
                                  </v-btn>
                                 </v-col>
                               
                                </v-row>      
                    </v-expansion-panel-content>
                    
                  </v-expansion-panel>

                     <v-expansion-panel v-if="datosEmbarcacion.tbr>=2000 && puerto=='Dos Bocas'" >
                    <v-expansion-panel-header  style="color:#98c1d9; font-weight:bold">Servicio de Remolcadores</v-expansion-panel-header>
                    <v-expansion-panel-content>
                       

                     <v-row no-gutters>
                                <v-col cols=4 v-if="estado!=1">
                                   <v-btn small fab dar color="" @click="agregarRemolcadoresDePemex()">
                                            <v-icon dark>compare_arrows
                                        </v-icon>
                                    </v-btn>
                                </v-col> 
                                  <v-col cols=4 v-if="estado===1">
                                   <v-btn disabled small fab dar color="" @click="agregarRemolcadoresDePemex()">
                                            <v-icon dark>compare_arrows
                                        </v-icon>
                                    </v-btn>
                                </v-col> 
                         </v-row>  
                          <v-row v-for="item in remolcadores" :key="item._id">
                                
                                <v-col cols="4" v-if="estado!=1">
                                    <v-select style="font-size:11px"
                                      :items="['Francisco Matías Vázquez Gutiérrez','Piloto Sindicato','Francisco Javier Elizalde Olguín']"
                                      label="Piloto"
                                      v-model="item.pilotoRemolcadores"
                                      dense
                                  ></v-select>
                                </v-col>
                                 <v-col cols="4" v-if="estado===1">
                                    <v-select style="font-size:11px"
                                      disabled
                                      :items="['Francisco Matías Vázquez Gutiérrez','Piloto Sindicato','Francisco Javier Elizalde Olguín']"
                                      label="Piloto"
                                      v-model="item.pilotoRemolcadores"
                                      dense
                                  ></v-select>
                                </v-col>
                                 

                               
                                <v-col cols="4" v-if="estado!=1">
                                   <v-select style="font-size:11px"
                                  :items="['Maya Maritima del Sureste','Asesores Profesionales en Transportación','Sistemas Inteligentes de Puebla','Transportación Maritima Portuaria Dos Bocas']"
                                  dense
                                  v-model="item.lanchajeRemolcadores"
                                  label="Lanchaje"
                                  ></v-select>
                                </v-col>
                                  <v-col cols="4" v-if="estado===1">
                                   <v-select style="font-size:11px"
                                   disabled
                                  :items="['Maya Maritima del Sureste','Asesores Profesionales en Transportación','Sistemas Inteligentes de Puebla','Transportación Maritima Portuaria Dos Bocas']"
                                  dense
                                  v-model="item.lanchajeRemolcadores"
                                  label="Lanchaje"
                                  ></v-select>
                                </v-col>
                                  <v-col cols="4" v-if="estado!=1">
                                      <v-text-field label="Fecha de Servicio" outlined  v-model="item.fechaServicioRemolcadores" dense></v-text-field>
                                  </v-col>
                                    <v-col cols="4" v-if="estado===1">
                                      <v-text-field label="Fecha de Servicio" disabled outlined  v-model="item.fechaServicioRemolcadores" dense></v-text-field>
                                  </v-col>
                                 
                                  <v-col cols="3" v-if="estado!=1">
                                      <v-text-field label="No Generador" outlined  v-model="item.noGeneradorRemolcadores" dense></v-text-field>
                                  </v-col>
                                    <v-col cols="4" v-if="estado===1">
                                      <v-text-field label="No Generador" disabled outlined  v-model="item.noGeneradorRemolcadores" dense></v-text-field>
                                  </v-col>
                                  
                                  <v-col cols="4" v-if="estado!=1">
                                          <v-text-field dense disabled style="font-size:11px" label="No Factura Piloto" v-model="item.noFacturaRemolcadoresPiloto"></v-text-field>
                                      </v-col>
                                      <v-col cols="4" v-if="estado===1">
                                          <v-text-field dense  style="font-size:11px" label="No Factura Piloto" v-model="item.noFacturaRemolcadoresPiloto"></v-text-field>
                                   </v-col>

                                     <v-col cols="4" v-if="estado!=1">
                                          <v-text-field dense disabled style="font-size:11px" label="No Factura Lanchaje" v-model="item.noFacturaRemolcadoresLanchaje"></v-text-field>
                                      </v-col>
                                      <v-col cols="4" v-if="estado===1">
                                          <v-text-field dense  style="font-size:11px" label="No Factura Lanchaje" v-model="item.noFacturaRemolcadoresLanchaje"></v-text-field>
                                   </v-col>
                                
                                   <v-col cols="12" v-if="estado!=1">
                                      <v-text-field label="Enlace Generador Remolcador"  prepend-icon="cloud_upload" v-model="item.enlaceFacturaRemolcador" dense></v-text-field>
                                    </v-col>
                                     <v-col cols="12" v-if="estado===1">
                                      <v-text-field label="Enlace Generador Remolcador" disabled prepend-icon="cloud_upload" v-model="item.enlaceFacturaRemolcador" dense></v-text-field>
                                    </v-col>
                                     <v-col cols="12" v-if="estado!=1">
                                      <v-text-field label="Enlace Factura Piloto" disabled prepend-icon="cloud_upload" v-model="item.enlaceFacturaPiloto" dense></v-text-field>
                                    </v-col>
                                     <v-col cols="12" v-if="estado===1">
                                      <v-text-field label="Enlace Factura Piloto"  prepend-icon="cloud_upload" v-model="item.enlaceFacturaPiloto" dense></v-text-field>
                                    </v-col>
                                      <v-col cols="12" v-if="estado!=1">
                                      <v-text-field label="Enlace Factura Lanchaje" disabled prepend-icon="cloud_upload" v-model="item.enlaceFacturaLanchaje" dense></v-text-field>
                                    </v-col>
                                     <v-col cols="12" v-if="estado===1">
                                      <v-text-field label="Enlace Factura Lanchaje"  prepend-icon="cloud_upload" v-model="item.enlaceFacturaLanchaje" dense></v-text-field>
                                    </v-col>
                                     <v-col cols="2" v-if="estado!=1">
                                        <v-btn small color="red" class="ma-2 white--text" @click="eliminarAmarradores(remolcadores,item)">Eliminar<v-icon right dark>
                                          delete
                                        </v-icon>
                                        </v-btn>                                
                                    </v-col>
                                     <v-col cols="2" v-if="estado===1">
                                        <v-btn small disabled color="red" class="ma-2 white--text" @click="eliminarAmarradores(remolcadores,item)">Eliminar<v-icon right dark>
                                          delete
                                        </v-icon>
                                        </v-btn>                                
                                    </v-col>
                                </v-row>  
                    </v-expansion-panel-content>
                    
                  </v-expansion-panel>

               

               

                 

                </v-expansion-panels>
              </div>
            </v-flex>
            <template>
  <v-divider></v-divider>
</template>
          

         
             <v-flex xs12 sm2 md12 lg12 xl12>
            
             <v-btn class="ma-2" @click.native="guardar()" outlined color="indigo">Guardar</v-btn>
             <v-btn class="ma-2" @click.native="ocultarNuevo()" outlined color="red">Salir</v-btn>
               
              
             </v-flex>  


        </v-layout>
    </v-container>

  </v-flex>


  </v-layout>

  
</template>
<script>
import S3 from "aws-s3";

import axios from "axios";
import DatetimePicker from "vuetify-datetime-picker";
import jsPDF from "jspdf";
import moment from 'moment'
import html2canvas from "html2canvas";
import swal from "sweetalert";
import emailjs from "emailjs-com";
import { required, email, minLength } from "vuelidate/lib/validators";
export default {
  icons: {
    iconfont: "fa4",
  },

  validations: {
    tipo: {
      required,
    },
    dates: {
      required,
    },
    muelle: {
      required,
    },

    embarcacion: {
      required,
    },
    compania: {
      required,
    },
    pasajeros: {
      required,
    },
    detalles: {
      required,
      minLength: minLength(10),
    },

    file3: {
      required,
    },
  },

  data() {
    return {
      search: "",
      cambiosGuardia: [],
      headers: [
        { text: "Actions", value: "action", sortable: false },
        { text: "Folio", value: "ag", sortable: true },
        { text: "Puerto", value: "puerto", sortable: true },
        { text: "Embarcacion", value: "embarcacion.nombre", sortable: true },
        { text: "Arribo", value: "arribo", sortable: false },
        { text: "Zarpe", value: "zarpe", sortable: false },
        { text: "Estatus", value: "estado", sortable: true },
      ],
      editedIndex: -1,
      _id: "",

      tiempoFinalParaCotizar:'',
      tiempoInicialParaCotizar:'',

      embarcacion: "",
      embarcaciones: [],
      muelles: ["FRONTERA", "CHILTEPEC", "SANCHEZ MAGALLANES"],
      muelle: "",
      nombreCompleto: "",
      dates: [],
      marca: "",
      entidadPilotoFalso:[],
      puerto:'',
      serviciosCapitania:false,
      serviciosEnmiendas:false,
      cliente:'',
      dialogCotizacion:false,
      dialogEstimacion:false,
      dialogFacturacion:false,
      serviciosAmarradores:false,
      agencias: [],
      tipo: "",
      folioCotizacion:'',
      programa:'',
      ingreso_mat: false,
      retiro_mat: false,
      panel: [0, 1, 2, 3, 4],
      pilotoEntrada:'',
      pilotoSalida:'',
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
         date2: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu: false,
      menu2: false,
      menu3:false,
      folioEstimacion:'',

      movimientoEntradaArribo:'',
      movimientoEntradaAtraque:'',
      movimientoSalidaZarpe:'',
      movimientoSalidaDesatraque:'',
    
    pilotoEntradaEntidad:'',
      pilotoEntradaTiempo:'',
      pilotoEntradaNoFactura:'',
      pilotoEntradaEnlace:'',
      pilotoSalidaEntidad:'',
      pilotoSalidaTiempo:'',
      pilotoSalidaNoFactura:'',
      pilotoSalidaEnlace:'',
      lanchajeEntradaEntidad:'',
      lanchajeEntradaTiempo:'',
      lamchajeEntradaNoFactura:'',
      lanchajeEntradaEnlace:'',
      lanchajeSalidaEntidad:'',
      lanchajeSalidaTiempo:'',
      lanchajeSalidaNoFactura:'',
      lanchajeSalidaEnlace:'',
      adminApi:[],
      enmiendaLanchaje:[],
      enmiendaPilotos:[],
      enmiendaPiloto:[],
      amarradores:[],
      pilotosFalso:[],
      remolcadores:[],
      menu1:false,
      manu3:false,
      compania: "",
      companias: [],
      capitania:[],
      pilotoEntrada:'',
      compania_aseguradora: "",
      nombre: "",
      lanchaje:[],
      file3: "",
      agencia2: "",
      tipos: ["Ayudante", "Chofer"],
      tipoServicio: "",
      agenciasUsuario: [],
      cabeceraDetalles: [
        { text: "Borrar", value: "borrar", sortable: false },
        { text: "Fecha y Hora", value: "nombreCompleto" },
        { text: "Movimiento", value: "compania" },
        { text: "Piloto", value: "puesto" },        
      ],
      cabeceraLanchaje:[
        {text:"Borrar",value:"borrar"},
         { text: "Fecha y Hora", value: "fechayhora" },
        { text: "Movimiento", value: "movimientoLanchaje" },
        { text: "Lanchaje", value: "lanchaje" },
      ],
      cabeceraAmarradores:[
        {text:"Borrar", value:"borrar"},
        {text:"Movimientos", value:"movimieto"},
        {text:"Fecha Servicio", value:"fechaServicioAmarradores"},
    
      ],
      cabeceraVehiculos: [
        { text: "Borrar", value: "borrar", sortable: false },
       
      ],

      adjuntos: [
        { text: "Tarjeta de Circulacion", value: "tarjetaCirculacion" },
        { text: "Poliza", value: "poliza" },
      ],
      pasajeros: [],
      vehiculos: [],
      verNuevo: 0,
      usuario: "",
      clientes:[],
      fecha_solicitud: "",
      agencia: "",
      amarradores:[],
      fecha: "",
      counter: "",
      pilotoFalso:false,
      pilotosFalso:[],
      vigencia: "",
      movimientosAgenciamientoLista:[],
      folio: "",
      lanchajeEntrada:'',
      lanchajeSalida:'',
       loader: null,
        loading: false,
      fecha: "",
      estado: "",
      datosEmbarcacion:[],
      placa: "",
      prueba: [],
      file: "",
      fechaActual: "",
      fechaFinal: "",
      vigenciaSeguro: "",
      ingreso_mat: "",
      retiro_mat: "",
      color: "",
      tipoVehiculo: "",
      remolcadores:[],
      file2: "",
      targetaCirculacion: "",
      poliza: "",
      detalles: "",
      valida: 0,
      nombreArchivo2: "",
      adpi:[],
      nombreArchivo3: "",
      fecha: null,
      validaMensaje: [],
      aprobacionAmls: "",
      aprobacionApi: "",
      adModal: 0,
      submited: "",
      dialog: false,
      modal: "",
      date: "",
      on: "",
      comprobanteModal: 0,
      adAccion: 0,
      nombreCompleto: "",
      cargo: "",
      adNombre: "",
      adId: "",
      deadline1ts:'',
      
      //Reporte
      folioAg:'',
      atraqueFecha:'',
      desatraqueFecha:'',
      pilotoSalida:'',
      adminpi:[],
      pilotosEnFalso:[],
    tiempoEnQueSeReviso:'',
    tiempoEnQueSeCotizo:'',
    tiempoEnQueSeEstimo:'',
    tiempoEnQueSeFacturo:'',

    recoleccionDeInformacion:'',
    tiempoEnQueSeReviso:''
    };
  },
  computed: {
   
    

    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Movimiento" : "Editar Movimiento";
    },

   
  },
  computed:{
     fechaInicialParaCotizar: function () {
      return this.deadline1ts
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.listar();
    this.selectEmbarcaciones();
    this.selectClientes();
    this.emailIn();
  },

  methods: {
 
    imprimir() {
      var objeto = document.getElementById("solicitudGuardia"); //obtenemos el objeto a imprimir
      var ventana = window.open("", "_blank"); //abrimos una ventana vacía nueva
      ventana.document.write(objeto.innerHTML); //imprimimos el HTML del objeto en la nueva ventana
      ventana.document.close(); //cerramos el documento
      ventana.print(); //imprimimos la ventana
      ventana.close(); //cerramos la ventana
    },

    mostrarComprobante(item) {
      this.limpiar();
      this.embarcacion = item.embarcacion;
      this.folioAg = item.ag
      var fecha = new Date();
      var options = { year: 'numeric', month: 'long', day: 'numeric' };
      this.fecha = fecha.toLocaleDateString("es-ES", options);
      var atraque = new Date(item.atraque)
      this.atraqueFecha = atraque.toLocaleDateString("es-Es",options);
      var desatraque = new Date(item.desatraque)
      this.desatraqueFecha = desatraque.toLocaleDateString("es-Es",options);
      this.puerto = item.puerto
      this.programa = item.programa
      this.pilotoEntrada = item.pilotoEntradaEntidad
      this.pilotoEntradaTiempo = item.pilotoEntradaTiempo
      this.pilotoEntradaNoFactura = item.pilotoEntradaFactura
      this.pilotoEntradaEnlace = item.pilotoEntradaEnlace
      this.pilotoSalida = item.pilotoSalidaEntidad
      this.pilotoSalidaTiempo = item.pilotoSalidaTiempo
      this.pilotoSalidaNoFactura = item.pilotoEntradaFactura
      this.pilotoSalidaEnlace = item.pilotoSalidaEnlace
      this.estado = item.estado
      this.lanchajeEntrada = item.lanchajeEntradaEntidad
      this.lanchajeEntradaTiempo = item.lanchajeEntradaTiempo
      this.lanchajeEntradaNoFactura = item.lanchajeEntradaFactura
      this.lanchajeEntradaEnlace = item.lanchajeEntradaEnlace
      this.clientes = item.cliente
      this.lanchajeSalida = item.lanchajeSalidaEntidad
      this.lanchajeSalidaTiempo = item.lanchajeSalidaTiempo
      this.lanchajeSalidaNoFactura = item.lanchajeSalidaFactura
      this.lanchajeSalidaEnlace = item.lanchajeSalidaEnlace

      this.deadline1ts = item.tiempoInicialParaCotizar
      this.adminpi = item.adminpi
      this.capitania = item.capitania
      this.enmiendaPilotos = item.enmiendaPiloto;
      this.enmiendaLanchaje = item.enmiendaLanchaje
      this.amarradores = item.amarradores
      this.pilotosEnFalso = item.pilotosEnFalso
      this.remolcadores = item.remolcadores

      let fecha1Revision = moment(item.zarpe)
      let fecha2Revision = moment(item.createdAt)
      let diaDeRevision =  fecha1Revision.diff(fecha2Revision, 'days')
      let horasDeRevisionTotal =  fecha1Revision.diff(fecha2Revision, 'hours')
      let horasDeRevisionAjustado = horasDeRevisionTotal-(diaDeRevision*24)
      this.recoleccionDeInformacion = (diaDeRevision+" Dias y "+horasDeRevisionAjustado+" horas de recolección de adjuntos")

      let fecha1RevisionInfo = moment(item.tiempoEnQueSeReviso)
      let fecha2RevisionInfo = moment(item.createdAt)
      let diaDeRevisionInfo =  fecha1RevisionInfo.diff(fecha2RevisionInfo, 'days')
      let horasDeRevisionTotalInfo =  fecha1RevisionInfo.diff(fecha2Revision, 'hours')
      let horasDeRevisionAjustadoInfo = horasDeRevisionTotalInfo-(diaDeRevisionInfo*24)
      this.tiempoEnQueSeReviso = (diaDeRevisionInfo+" Dias y "+horasDeRevisionAjustadoInfo+" horas de revision")

      let fecha1Cotizado = moment(item.tiempoEnQueSeReviso)
      let fecha2Cotizado = moment(item.tiempoEnQueSeCotizo)
      let diaDeCotizado =  fecha1Cotizado.diff(fecha2Cotizado, 'days')
      let horasDeCotizado =  fecha1Cotizado.diff(fecha2Cotizado, 'hours')
      let horasDeCotizadoAjustadoInfo = horasDeCotizado-(diaDeCotizado*24)
      this.tiempoEnQueSeCotizo = (diaDeCotizado+" Dias y "+horasDeCotizadoAjustadoInfo+" horas en cotizar")

      let fecha1Estimado = moment(item.tiempoEnQueSeEstimo)
      let fecha2Estimado = moment(item.tiempoEnQueSeCotizo)
      let diaDeEstimado =  fecha1Estimado.diff(fecha2Estimado, 'days')
      let horasDeEstimado =  fecha1Estimado.diff(fecha2Estimado, 'hours')
      let horasDeEstimadoAjustadoInfo = horasDeEstimado-(diaDeEstimado*24)
      this.tiempoEnQueSeEstimo = (diaDeEstimado+" Dias y "+horasDeEstimadoAjustadoInfo+" horas en estimar")

      let fecha1Facturado = moment(item.tiempoEnQueSeFacturo)
      let fecha2Facturado = moment(item.tiempoEnQueSeEstimo)
      let diaDeFacturado =  fecha1Facturado.diff(fecha2Facturado, 'days')
      let horasDeFacturado =  fecha1Facturado.diff(fecha2Facturado, 'hours')
      let horasDeFacturadoAjustadoInfo = horasDeFacturado-(diaDeFacturado*24)
      this.tiempoEnQueSeFacturo = (diaDeFacturado+" Dias y "+horasDeFacturadoAjustadoInfo+" horas en estimar")



      this.comprobanteModal = 1;

  
    },
    ocultarComprobante(item) {
      this.comprobanteModal = 0;
    },

    mostrarNuevo() {
      this.limpiar();
      this.verNuevo = 1;
     
    },
    ocultarNuevo() {
      this.verNuevo = 0;
      this.limpiar();
    },

    eliminarPasajero(arr, item) {
      let i = arr.indexOf(item);
      if (i != -1) {
        arr.splice(i, 1);
      }
    },

     eliminarAmarradores(arr, item) {
      let i = arr.indexOf(item);
      if (i != -1) {
        arr.splice(i, 1);
      }
    },

    eliminarVehiculo(arr, item) {
      let i = arr.indexOf(item);
      if (i != -1) {
        arr.splice(i, 1);
      }
    },

    emailIn() {
      emailjs.init("user_QA8qMBuyHCQIHTgR0AsPx");
    },

      enviar(embarcacion,puerto,programa,folio){
                 

         var template_params = {
             "embarcacion":embarcacion,
              "puerto": puerto,
              "programa": programa,
              "folio": folio,
                        }
                        
               emailjs.send("gmail","servicioAgenciamiento", template_params)
                .then(function(response) {
                   if(response.text === 'OK'){        
                  }
                    console.log("SUCCESS. status=%d, text=%s", response.status, response.text);
                  }, function(err) {
                  alert('Ocurrió un problema al enviar el correo');
                console.log("FAILED. error=", err);
             });
                
       },

        enviarCotizado(embarcacion,puerto,programa,fechaArribo,fechaZarpe,folio){
                 

         var template_params = {
             "embarcacion":embarcacion,
              "puerto": puerto,
              "programa": programa,
              "fechaArribo": fechaArribo,
              "fechaZarpe" : fechaZarpe,
              "folio": folio,
                        }
                        
               emailjs.send("gmail","AgenciamientoTiempos", template_params)
                .then(function(response) {
                   if(response.text === 'OK'){        
                  }
                    console.log("SUCCESS. status=%d, text=%s", response.status, response.text);
                  }, function(err) {
                  alert('Ocurrió un problema al enviar el correo');
                console.log("FAILED. error=", err);
             });
                
       },
       enviarEnlaces(embarcacion,puerto,programa,fechaArribo,fechaZarpe,folio){
                 

         var template_params = {
             "embarcacion":embarcacion,
              "puerto": puerto,
              "programa": programa,
              "fechaArribo": fechaArribo,
              "fechaZarpe" : fechaZarpe,
              "folio": folio,
                        }
                        
               emailjs.send("gmail","AgenciamientoEnlaces", template_params)
                .then(function(response) {
                   if(response.text === 'OK'){        
                  }
                    console.log("SUCCESS. status=%d, text=%s", response.status, response.text);
                  }, function(err) {
                  alert('Ocurrió un problema al enviar el correo');
                console.log("FAILED. error=", err);
             });
                
       },

       enviarEstimado(embarcacion,puerto,programa,fechaArribo,fechaZarpe,folio,folioCotizacion){
                 

         var template_params = {
             "embarcacion":embarcacion,
              "puerto": puerto,
              "programa": programa,
              "fechaArribo": fechaArribo,
              "fechaZarpe" : fechaZarpe,
              "folio": folio,
              "folioCotizacion":folioCotizacion
                        }
                        
               emailjs.send("gmail","agenciamientoEstimado", template_params)
                .then(function(response) {
                   if(response.text === 'OK'){        
                  }
                    console.log("SUCCESS. status=%d, text=%s", response.status, response.text);
                  }, function(err) {
                  alert('Ocurrió un problema al enviar el correo');
                console.log("FAILED. error=", err);
             });
                
       },

        enviarFacturado(embarcacion,puerto,programa,fechaArribo,fechaZarpe,folio,folioEstimacion){
                 

         var template_params = {
             "embarcacion":embarcacion,
              "puerto": puerto,
              "programa": programa,
              "fechaArribo": fechaArribo,
              "fechaZarpe" : fechaZarpe,
              "folio": folio,
              "folioEstimacion":folioEstimacion
                        }
                        
               emailjs.send("gmail","agenciamientoFacturado", template_params)
                .then(function(response) {
                   if(response.text === 'OK'){        
                  }
                    console.log("SUCCESS. status=%d, text=%s", response.status, response.text);
                  }, function(err) {
                  alert('Ocurrió un problema al enviar el correo');
                console.log("FAILED. error=", err);
             });
                
       },

         servicioFacturado(embarcacion,puerto,programa,fechaArribo,fechaZarpe,folio,folioFactura){
                 

         var template_params = {
             "embarcacion":embarcacion,
              "puerto": puerto,
              "programa": programa,
              "fechaArribo": fechaArribo,
              "fechaZarpe" : fechaZarpe,
              "folio": folio,
              "folioFactura":folioFactura
                        }
                        
               emailjs.send("gmail","ServicioFacturado", template_params)
                .then(function(response) {
                   if(response.text === 'OK'){        
                  }
                    console.log("SUCCESS. status=%d, text=%s", response.status, response.text);
                  }, function(err) {
                  alert('Ocurrió un problema al enviar el correo');
                console.log("FAILED. error=", err);
             });
                
       },

     listarEmbarcacion(embarcacion,puerto,programa,folio){
            let header={"Token":this.$store.state.token};
            let me=this;
            
            let configuracion= {headers: header}
            axios.get('embarcacion/query?_id='+embarcacion,configuracion).then(function (response){
            embarcacion=response.data;
            
            me.enviar(embarcacion,puerto,programa,folio)
            }).catch(function(error){
              console.log(error)
            })
      },

       listarEmbarcacionCotizado(embarcacion,puerto,programa,fechaArribo,fechaZarpe,folio){
            let header={"Token":this.$store.state.token};
            let me=this;
            
            let configuracion= {headers: header}
            axios.get('embarcacion/query?_id='+embarcacion,configuracion).then(function (response){
            embarcacion=response.data;
            
            me.enviarCotizado(embarcacion,puerto,programa,fechaArribo,fechaZarpe,folio)
            }).catch(function(error){
              console.log(error)
            })
      },
      listarEmbarcacionEnlaces(embarcacion,puerto,programa,fechaArribo,fechaZarpe,folio){
            let header={"Token":this.$store.state.token};
            let me=this;
            
            let configuracion= {headers: header}
            axios.get('embarcacion/query?_id='+embarcacion,configuracion).then(function (response){
            embarcacion=response.data;
            
            me.enviarEnlaces(embarcacion,puerto,programa,fechaArribo,fechaZarpe,folio)
            }).catch(function(error){
              console.log(error)
            })
      },

      listarEmbarcacionEstimado(embarcacion,puerto,programa,fechaArribo,fechaZarpe,folio,folioCotizacion){
            let header={"Token":this.$store.state.token};
            let me=this;
            
            let configuracion= {headers: header}
            axios.get('embarcacion/query?_id='+embarcacion,configuracion).then(function (response){
            embarcacion=response.data;
            
            me.enviarEstimado(embarcacion,puerto,programa,fechaArribo,fechaZarpe,folio,folioCotizacion)
            }).catch(function(error){
              console.log(error)
            })
      },
      
      listarEmbarcacionFacturado(embarcacion,puerto,programa,fechaArribo,fechaZarpe,folio,folioEstimacion){
            let header={"Token":this.$store.state.token};
            let me=this;
            
            let configuracion= {headers: header}
            axios.get('embarcacion/query?_id='+embarcacion,configuracion).then(function (response){
            embarcacion=response.data;
            
            me.enviarFacturado(embarcacion,puerto,programa,fechaArribo,fechaZarpe,folio,folioEstimacion)
            }).catch(function(error){
              console.log(error)
            })
      },

      servicioFacturadoEnviar(embarcacion,puerto,programa,fechaArribo,fechaZarpe,folio,folioFactura){
            let header={"Token":this.$store.state.token};
            let me=this;
            
            let configuracion= {headers: header}
            axios.get('embarcacion/query?_id='+embarcacion,configuracion).then(function (response){
            embarcacion=response.data;
            
            me.servicioFacturado(embarcacion,puerto,programa,fechaArribo,fechaZarpe,folio,folioFactura)
            }).catch(function(error){
              console.log(error)
            })
      },

      

  

  

 

    selectEmbarcaciones() {
      let me = this;
      let embarcacionArray = [];
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("embarcacion/listActivos", configuracion)
        .then((response) => {
          embarcacionArray = response.data;
          embarcacionArray.map(function (x) {
            me.embarcaciones.push({ text: x.nombre, value: x._id });
          });
   
        })
        .catch(function (error) {
          console.log(error);
        });
    },

     selectClientes() {
      let me = this;
      let clienteArray = [];
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("cliente/list", configuracion)
        .then((response) => {
          clienteArray = response.data;
          clienteArray.map(function (x) {
            me.clientes.push({ text: x.nombre_comercial, value: x._id });
          });
   
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    selectAgencias() {
      let me = this;
      let agencaiArray = [];
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      
      axios
        .get("agencia/list", configuracion)
        .then((response) => {
          agencaiArray = response.data;
          agencaiArray.map(function (x) {
            me.agencias.push({ text: x.nombre, value: x._id });
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    mostrarDetallesDeEmbarcacion(){
      let me = this;
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("embarcacion/queryDatos?_id=" + this.embarcacion, configuracion)
        .then(function (response) {
          me.datosEmbarcacion = response.data;
          console.log(me.datosEmbarcacion)
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    validar() {
      this.valida = 0;
      this.validaMensaje = [];
      if (!this.embarcacion) {
        this.validaMensaje.push("La embarcación es obligatorio");
      }

      if (!this.muelle) {
        this.validaMensaje.push("El muelle es obligatoria");
      }

      if (this.validaMensaje.length) {
        this.valida = 1;
      }
      return this.valida;
    },

    modificarSwitch(){
      if(this.puerto=='Ciudad del Carmen'){
        this.serviciosEnmiendas=false
        this.serviciosAmarradores=false
        this.pilotoFalso=false
        this.pilotoEntradaEntidad='Sindicato Nacional de Pilotos de Puerto Dele CME'
        this.pilotoSalidaEntidad='Sindicato Nacional de Pilotos de Puerto Dele CME'
        this.lanchajeEntradaEntidad='Puerto Mar'
        this.lanchajeSalidaEntidad='Puerto Mar'
       // this.pilotoFalso = 'Sindicato Nacional de Pilotos de Puerto Dele CME'
        for(let i = this.pilotosFalso.length; i>0; i--){
          this.pilotosFalso.pop()
        }
        
      }
       else if(this.puerto=='Seybaplaya'){
        this.serviciosEnmiendas=false
        this.serviciosAmarradores=false
        this.pilotoFalso=false
        this.pilotoEntradaEntidad='Sindicato Nacional de Pilotos de Puerto Dele Campeche'
        this.pilotoSalidaEntidad='Sindicato Nacional de Pilotos de Puerto Dele Campeche'
        this.lanchajeEntradaEntidad='Ah Kim Pech'
        this.lanchajeSalidaEntidad='Ah Kim Pech'
           for(let i = this.pilotosFalso.length; i>0; i--){
          this.pilotosFalso.pop()
        }
       
      }
       else if(this.puerto=='Frontera'){
        this.pilotoEntradaEntidad='Sindicato Nacional de Pilotos de Puerto Dele Zentla'
        this.pilotoSalidaEntidad='Sindicato Nacional de Pilotos de Puerto Dele Zentla'
        this.lanchajeEntradaEntidad='Pedro Rosas Salas'
        this.lanchajeSalidaEntidad='Pedro Rosas Salas'
        this.serviciosEnmiendas=false
        this.serviciosAmarradores=false
        this.pilotoFalso=false
      }
       else if(this.puerto=='Chiltepec'){
        this.serviciosEnmiendas=false
        this.serviciosAmarradores=false
        this.pilotoFalso=false
      }
    },

    agregarPiloto() {
     
      if(this.puerto == 'Frontera'){
       this.enmiendaPilotos.push({
        fechaHoraPilotoEnmienda: "",
        movimientoPilotoEnmienda: "",
        PilotoEnmienda: "Sindicato Nacional de Pilotos de Puerto Dele Zentla",
        enlacePilotoEnmienda: "",
      });
     }else if(this.puerto == 'Ciudad del Carmen'){
         this.enmiendaPilotos.push({
        fechaHoraPilotoEnmienda: "",
        movimientoPilotoEnmienda: "",
        PilotoEnmienda: "Sindicato Nacional de Pilotos de Puerto Dele CME",
        enlacePilotoEnmienda: "",
      });
     }else if(this.puerto == 'Seybaplaya'){
          this.enmiendaPilotos.push({
        fechaHoraPilotoEnmienda: "",
        movimientoPilotoEnmienda: "",
        PilotoEnmienda: "Sindicato Nacional de Pilotos de Puerto Dele Campeche",
        enlacePilotoEnmienda: "",
      });
    }else if(this.puerto == 'Dos Bocas'){
          this.enmiendaPilotos.push({
          fechaHoraLanchajeEnmienda: "",
          movimientoLanchajeEnmienda: "",
          lanchajeEnmienda: "",
          enlanceLanchajeEnlace: "",
      });
      
     }
  },
    agregarLanchaje(){
     if(this.puerto == 'Frontera'){
        this.enmiendaLanchaje.push({
          fechaHoraLanchajeEnmienda: "",
          movimientoLanchajeEnmienda: "",
          lanchajeEnmienda: "Pedro Rosas Salas",
          enlanceLanchajeEnlace: "",
      });
     }else if(this.puerto == 'Ciudad del Carmen'){
          this.enmiendaLanchaje.push({
          fechaHoraLanchajeEnmienda: "",
          movimientoLanchajeEnmienda: "",
          lanchajeEnmienda: "Puerto Mar",
          enlanceLanchajeEnlace: "",
      });
     }else if(this.puerto == 'Seybaplaya'){
          this.enmiendaLanchaje.push({
          fechaHoraLanchajeEnmienda: "",
          movimientoLanchajeEnmienda: "",
          lanchajeEnmienda: "Ah Kim Pech",
          enlanceLanchajeEnlace: "",
      });
      
     }else if(this.puerto == 'Dos Bocas'){
          this.enmiendaLanchaje.push({
          fechaHoraLanchajeEnmienda: "",
          movimientoLanchajeEnmienda: "",
          lanchajeEnmienda: "",
          enlanceLanchajeEnlace: "",
      });
      
     }
     
    },
    agregarAmarrador() {
      this.amarradores.push({
        folioFactura:"",
        movimiento: "",
        fechaServicio: "",
        enlace: "",
      });
    },

    agregarCapitania() {
      this.capitania.push({
        hojaAyuda: "",
        factura: "",
        enlaceFactura: "",
        enlaceHojaAyuda:""
      });
    },
    agregarApi(){
      this.adminApi.push({
        fechaServicio:"",
        movimientoApi:"",
        noFactura:"",
        enlaceFactura:""
      })
    },

    agregarVehiculos() {
      this.vehiculos.push({
        marca: "",
        placa: "",
        vigenciaSeguro: "",
        color: "",
        tipoVehiculo: "",
        targetaCirculacion: "",
        poliza: "",
        compania_aseguradora: "",
      });
    },
    agregarPilotoFalso(){
      if(this.puerto=='Ciudad del Carmen'){
        this.pilotosFalso.push({
          entidadPilotoFalso:'Sindicato Nacional de Pilotos Dele CME',
          tiempoPilotoFalso:'',
          noFacturaPilotoFalso:'',
          enlacePilotoFalso:'',
          entidadLanchajeFalso:'Puerto Mar',
          tiempoLanchajeFalso:'',
          noFacturaLanchaje:'',
          enlaceLanchajeFalso:''
        })
      }else if(this.puerto=='Seybaplaya'){
        this.pilotosFalso.push({
           entidadPilotoFalso:'Sindicato Nacional de Pilotos Dele Campeche',
          tiempoPilotoFalso:'',
          noFacturaPilotoFalso:'',
          enlacePilotoFalso:'',
          entidadLanchajeFalso:'Ah Kim Pech',
          tiempoLanchajeFalso:'',
          noFacturaLanchaje:'',
          enlaceLanchajeFalso:''
        })
      }else if(this.puerto=='Frontera'){
           this.pilotosFalso.push({
           entidadPilotoFalso:'Sindicato Nacional de Pilotos Dele Zentla',
          tiempoPilotoFalso:'',
          noFacturaPilotoFalso:'',
          enlacePilotoFalso:'',
          entidadLanchajeFalso:'Pedro Rosas Salas',
          tiempoLanchajeFalso:'',
          noFacturaLanchaje:'',
          enlaceLanchajeFalso:''
        })
      }else if(this.puerto=='Dos Bocas'){
          this.pilotosFalso.push({
          entidadPilotoFalso:'',
          tiempoPilotoFalso:'',
          noFacturaPilotoFalso:'',
          enlacePilotoFalso:'',
          entidadLanchajeFalso:'',
          tiempoLanchajeFalso:'',
          noFacturaLanchaje:'',
          enlaceLanchajeFalso:''
        })
      }
     
    },
    agregarRemolcadoresDePemex(){
      this.remolcadores.push({
        piloto:'',
        noFacturaPiloto:'',
        enlaceFacturaPiloto:'',
        lanchaje:'',
        noFacturaLanchaje:'',
        enlaceFacturaLanchaje:'',
        tiempoRemolcador:'',
        noGenerador:'',
        enlaceFacturaRemolcador:''
      })
    },

    limpiar() {
              this._id=''
               this.embarcacion='',
               this.puerto='',
               this.programa='',
               this.arribo='',
               this.atraque='',
               this.zarpe='',
               this.desatraque='',
               this.pilotoEntradaEntidad='',
               this.pilotoEntradaTiempo='',
               this.pilotoEntradaFactura='',
               this.pilotoEntradaEnlace='',
               this.pilotoSalidaEntidad='',
               this.pilotoSalidaTiempo='',
               this.pilotoSalidaFactura='',
               this.pilotoSalidaEnlace='',
               this.lanchajeEntradaEntidad='',
               this.lanchajeEntradaTiempo='',
               this.lanchajeEntradaFactura='',
               this.lanchajeEntradaEnlace='',
               this.lanchajeSalidaEntidad='',
               this.lanchajeSalidaTiempo='',
               this.lanchajeSalidaFactura='',
               this.lanchajeSalidaEnlace='',
               this.capitania=[],
               this.adminpi=[],
               this.enmiendaPilotos=[],
               this.enmiendaLanchaje=[],
               this.amarradores=[],
               this.pilotosEnFalso=[],
               this.remolcadores=[],
               this.estado=0,
        (this.valida = 0),
        (this.validaMensaje = []),
        (this.editedIndex = -1);
    },


    guardar() {
      
      let me = this;
      console.log(this.pilotosFalso)
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };


       if (this.editedIndex > -1 && this.pilotoEntradaEnlace && this.pilotoEntradaNoFactura && this.pilotoSalidaEnlace && this.pilotoSalidaNoFactura) {
        axios
          .put(
            "movimientoAgenciamiento/updateAdministrativo",
            {
              _id: this._id,
               embarcacion: this.embarcacion,
              puerto: this.puerto,
              programa: this.programa,
              arribo: this.movimientoEntradaArribo,
              atraque: this.movimientoEntradaAtraque,
              zarpe: this.movimientoSalidaZarpe,
              desatraque: this.movimientoSalidaDesatraque,
              pilotoEntradaEntidad: this.pilotoEntradaEntidad,
              pilotoEntradaTiempo: this.pilotoEntradaTiempo,
              pilotoEntradaFactura: this.pilotoEntradaFactura,
              pilotoEntradaEnlace: this.pilotoEntradaEnlace,
              pilotoSalidaEntidad: this.pilotoSalidaEntidad,
              pilotoSalidaTiempo: this.pilotoSalidaTiempo,
              pilotoSalidaFactura: this.pilotoSalidaFactura,
              pilotoSalidaEnlace: this.pilotoSalidaEnlace,
              lanchajeEntradaEntidad: this.lanchajeEntradaEntidad,
              lanchajeEntradaTiempo: this.lanchajeEntradaTiempo,
              lanchajeEntradaFactura: this.lanchajeEntradaNoFactura,
              lanchajeEntradaEnlace: this.lanchajeEntradaEnlace,
              lanchajeSalidaEntidad: this.lanchajeSalidaEntidad,
              lanchajeSalidaTiempo: this.lanchajeSalidaTiempo,
              lanchajeSalidaFactura: this.lanchajeSalidaNoFactura,
              lanchajeSalidaEnlace: this.lanchajeSalidaEnlace,
              capitania:this.capitania,
              adminpi:this.adminApi,
              enmiendaPiloto:this.enmiendaPilotos,
              enmiendaLanchaje:this.enmiendaLanchaje,
              amarradores:this.amarradores,
              pilotosEnFalso:this.pilotosFalso,
              remolcadores:this.remolcadores
            },
            configuracion
          )
          .then(function (response) {
            
            swal(
              "Nueva Solicitud de Acceso Actualizada",
              "Solicitud de acceso a vehiculos y personal actualizada exitosamente",
              "success"
            );
            me.listar(); 
            me.limpiar();
            me.ocultarNuevo();
            me.close();
            
          })
          
          .catch(function (error) {
            me.close();
            swal(
              "Error",
              "Error al ingresar la solicitud, verifica los datos ingresados",
              "error"
            );
          });
      }
   

     else if (this.editedIndex > -1 ) {
      

        axios
          .put(
            "movimientoAgenciamiento/update",
            {
              _id: this._id,
               embarcacion: this.embarcacion,
              puerto: this.puerto,
              programa: this.programa,
              arribo: this.movimientoEntradaArribo,
              atraque: this.movimientoEntradaAtraque,
              zarpe: this.movimientoSalidaZarpe,
              desatraque: this.movimientoSalidaDesatraque,
              pilotoEntradaEntidad: this.pilotoEntradaEntidad,
              pilotoEntradaTiempo: this.pilotoEntradaTiempo,
              pilotoEntradaFactura: this.pilotoEntradaFactura,
              pilotoEntradaEnlace: this.pilotoEntradaEnlace,
              pilotoSalidaEntidad: this.pilotoSalidaEntidad,
              pilotoSalidaTiempo: this.pilotoSalidaTiempo,
              pilotoSalidaFactura: this.pilotoSalidaFactura,
              pilotoSalidaEnlace: this.pilotoSalidaEnlace,
              lanchajeEntradaEntidad: this.lanchajeEntradaEntidad,
              lanchajeEntradaTiempo: this.lanchajeEntradaTiempo,
              lanchajeEntradaFactura: this.lanchajeEntradaNoFactura,
              lanchajeEntradaEnlace: this.lanchajeEntradaEnlace,
              lanchajeSalidaEntidad: this.lanchajeSalidaEntidad,
              lanchajeSalidaTiempo: this.lanchajeSalidaTiempo,
              lanchajeSalidaFactura: this.lanchajeSalidaNoFactura,
              lanchajeSalidaEnlace: this.lanchajeSalidaEnlace,
              capitania:this.capitania,
              adminapi:this.adminApi,
              enmiendaPiloto:this.enmiendaPilotos,
              enmiendaLanchaje:this.enmiendaLanchaje,
              amarradores:this.amarradores,
              pilotosEnFalso:this.pilotosFalso,
              remolcadores:this.remolcadores,
            },
            configuracion
          )
          .then(function (response) {
            swal(
              "Nueva Solicitud de Acceso Actualizada",
              "Solicitud de acceso a vehiculos y personal actualizada exitosamente",
              "success"
            );
           
            me.listar();
            me.limpiar();
            me.ocultarNuevo();
            me.close();
          })
          
          .catch(function (error) {
            me.close();
            swal(
              "Error",
              "Error al ingresar la solicitud, verifica los datos ingresados",
              "error"
            );
          });
      } else {
       
        axios
          .post(
            "movimientoAgenciamiento/add",
            {
              embarcacion: this.embarcacion,
              puerto: this.puerto,
              programa: this.programa,
              arribo: this.movimientoEntradaArribo,
              atraque: this.movimientoEntradaAtraque,
              zarpe: this.movimientoSalidaZarpe,
              desatraque: this.movimientoSalidaDesatraque,
              pilotoEntradaEntidad: this.pilotoEntradaEntidad,
              pilotoEntradaTiempo: this.pilotoEntradaTiempo,
              pilotoEntradaFactura: this.pilotoEntradaFactura,
              pilotoEntradaEnlace: this.pilotoEntradaEnlace,
              pilotoSalidaEntidad: this.pilotoSalidaEntidad,
              pilotoSalidaTiempo: this.pilotoSalidaTiempo,
              pilotoSalidaFactura: this.pilotoSalidaFactura,
              pilotoSalidaEnlace: this.pilotoSalidaEnlace,
              lanchajeEntradaEntidad: this.lanchajeEntradaEntidad,
              lanchajeEntradaTiempo: this.lanchajeEntradaTiempo,
              lanchajeEntradaFactura: this.lanchajeEntradaNoFactura,
              lanchajeEntradaEnlace: this.lanchajeEntradaEnlace,
              lanchajeSalidaEntidad: this.lanchajeSalidaEntidad,
              lanchajeSalidaTiempo: this.lanchajeSalidaTiempo,
              lanchajeSalidaFactura: this.lanchajeSalidaNoFactura,
              lanchajeSalidaEnlace: this.lanchajeSalidaEnlace,
              capitania:this.capitania,
              adminpi:this.adminApi,
              cliente:this.cliente,
              enmiendaPiloto:this.enmiendaPilotos,
              enmiendaLanchaje:this.enmiendaLanchaje,
              amarradores:this.amarradores,
              pilotosEnFalso:this.pilotosFalso,
              remolcadores:this.remolcadores
            },
            configuracion
         )
          .then(function (response) {
            swal(
              "Nuevo Servicio de Agenciamiento",
              "Servicio de Agenciamiento agregado exitosamente",
              "success"
            );
            // let arribo = new Date(item.arribo)
            // let zarpe = new Date(item.zarpe)
            // let arriboMoment = moment()
            me.listar()

            me.listarEmbarcacion(response.data.embarcacion,response.data.puerto, response.data.programa,response.data.ag)
            me.limpiar();
            me.ocultarNuevo();
            me.close();
          })
          .catch(function (error) {
            me.close();
            swal(
              "Error",
              "Error al ingresar la solicitud, verifique los datos ingresadoss",
              "error"
            );
          });
      }
    },

 
    listar() {
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      let me = this;
      axios
        .get(
          "movimientoAgenciamiento/list",
          configuracion
        )
        .then(function (response) {
          console.log(response.data)
          me.movimientosAgenciamientoLista = response.data;
          console.log(response.data)
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    actualizarPilotosFalso(){
      if(this.pilotoFalso==false){
        this.pilotosFalso.length=0
      }
    },    
    actualizarCapitania(){
      if(this.serviciosCapitania==false){
        this.capitania.length=0
      }
    },
    actualizarServiciosEnmienda(){
      if(this.serviciosEnmiendas==false){
        this.enmiendaLanchaje.length=0
        this.enmiendaPilotos.length=0
      }
    },
    actualizarServiciosAmarradores(){
      if(this.serviciosAmarradores==false){
        this.amarradores.length=0
      }
    },

   

  

 
    editItem(item) {
      this.limpiar();
      this._id = item._id
      //Informacion
      this.puerto = item.puerto;
      this.embarcacion = item.embarcacion._id;
      this.programa = item.programa;
      this.modificarSwitch()
      this.mostrarDetallesDeEmbarcacion()
     
      //Movimientos
      var arriboEspanol = new Date(item.arribo)
      this.movimientoEntradaArribo = arriboEspanol
      var atraqueEntrada = new Date(item.atraque)
      this.movimientoEntradaAtraque = atraqueEntrada
      var zarpeSalida = new Date(item.zarpe)
      this.movimientoSalidaZarpe= zarpeSalida
      var desatraqueSalida = new Date(item.desatraque)
      this.movimientoSalidaDesatraque = desatraqueSalida

      //Pilotos
      this.pilotoEntradaEntidad= item.pilotoEntradaEntidad
      this.pilotoEntradaTiempo = item.pilotoEntradaTiempo
      this.pilotoEntradaFactura  = item.pilotoEntradaFactura
      this.pilotoEntradaEnlace = item.pilotoEntradaEnlace

      this.pilotoSalidaEntidad = item.pilotoSalidaEntidad
      this.pilotoSalidaTiempo = item.pilotoSalidaTiempo
      this.pilotoSalidaFactura = item.pilotoSalidaFactura
      this.pilotoSalidaEnlace = item.pilotoSalidaEnlace

      this.lanchajeEntradaEntidad = item.lanchajeEntradaEntidad
      this.lanchajeEntradaTiempo = item.lanchajeEntradaTiempo
      this.lanchajeEntradaEnlace = item.lanchajeEntradaEnlace
      this.lanchajeEntradaNoFactura = item.lanchajeEntradaFactura

      this.lanchajeSalidaEntidad = item.lanchajeSalidaEntidad
      this.lanchajeSalidaTiempo = item.lanchajeSalidaTiempo
      this.lanchajeSalidaNoFactura = item.lanchajeSalidaFactura
      this.lanchajeSalidaEnlace = item.lanchajeSalidaEnlace

      this.tiempoInicialParaCotizar = item.tiempoInicialParaCotizar;
      this.tiempoFinalParaCotizar = item.tiempoFinalParaCotizar
      
      //Capitania
      if(item.capitania.length > 0){
        this.serviciosCapitania=true,
        this.capitania = item.capitania
      }
      //API 
      this.adminApi = item.adminpi
      console.log(this.adminApi)

      //Enmiendas
      
      if(item.enmiendaPiloto.length >0 || item.enmiendaLanchaje.length>0){
              this.serviciosEnmiendas=true

        this.enmiendaLanchaje= item.enmiendaLanchaje
        this.enmiendaPilotos = item.enmiendaPiloto
      
      }

      //Servicios de Amarradores  
      
      if(item.amarradores.length > 0){
        this.serviciosAmarradores = true
        this.amarradores = item.amarradores  
      }

      //Pilotos en Falso

      if(item.pilotosEnFalso.length>0){
        this.pilotoFalso = true
        this.pilotosFalso= item.pilotosEnFalso
      }

      this.remolcadores = item.remolcadores
      this.estado = item.estado;



     
      this.editedIndex = 1;
      this.dialog = false;
      this.verNuevo = 1;
    },

 
  test(item){
   console.log('Hi')
  },
 

   
    revisado(id) {
      let me = this;
      this.limpiar()
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
  
      

      axios
        .put("movimientoAgenciamiento/revisado", { _id: id,

          },
          configuracion)
        .then(function (response) {
          me.listarEmbarcacionEnlaces(response.data.embarcacion,response.data.puerto, response.data.programa, moment(response.data.arribo).format('MMMM Do YYYY, h:mm:ss a'), moment(response.data.zarpe).format('MMMM Do YYYY, h:mm:ss a'),response.data.ag)
          me.listar();       
          me.limpiar();
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    
    listo(id) {
      let me = this;
      this.limpiar()
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
  
      

      axios
        .put("movimientoAgenciamiento/listo", { _id: id,

          },
          configuracion)
        .then(function (response) {
          me.listarEmbarcacionCotizado(response.data.embarcacion,response.data.puerto, response.data.programa, moment(response.data.arribo).format('MMMM Do YYYY, h:mm:ss a'), moment(response.data.zarpe).format('MMMM Do YYYY, h:mm:ss a'),response.data.ag)
          me.listar();       
          me.limpiar();
        })
        .catch(function (error) {
          console.log(error);
        });
    },

     cotizado(id,folio) {
      let me = this;
     this.limpiar()
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .put("movimientoAgenciamiento/cotizado",
         {
           _id: id,
           folioCotizacion:folio
         }, configuracion)
        .then(function (response) {
          console.log(response.data)
          me.listarEmbarcacionEstimado(response.data.embarcacion,response.data.puerto, response.data.programa, moment(response.data.arribo).format('MMMM Do YYYY, h:mm:ss a'), moment(response.data.zarpe).format('MMMM Do YYYY, h:mm:ss a'),response.data.ag,folio)
          me.listar();
          me.limpiar();
          
        })
        .catch(function (error) {
          console.log(error);
        });
    },

     estimado(id,folio) {
      let me = this;
       this.limpiar()
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .put("movimientoAgenciamiento/estimado",
         {
           _id: id,
           folioEstimacion:folio
         }, configuracion)
        .then(function (response) {
          me.listarEmbarcacionFacturado(response.data.embarcacion,response.data.puerto, response.data.programa, moment(response.data.arribo).format('MMMM Do YYYY, h:mm:ss a'), moment(response.data.zarpe).format('MMMM Do YYYY, h:mm:ss a'),response.data.ag,folio)
          me.dialogEstimacion=false
          me.listar();
          me.limpiar()
        })
        .catch(function (error) {
          console.log(error);
        });
    },

     facturado(id,folio) {
      let me = this;
      this.limpiar()
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .put("movimientoAgenciamiento/facturado",
         {
           _id: id,
           folioFactura:folio
         }, configuracion)
        .then(function (response) {
          me.servicioFacturadoEnviar(response.data.embarcacion,response.data.puerto, response.data.programa, moment(response.data.arribo).format('MMMM Do YYYY, h:mm:ss a'), moment(response.data.zarpe).format('MMMM Do YYYY, h:mm:ss a'),response.data.ag,folio)
          me.dialogFacturacion=false
          me.limpiar()
          me.listar();
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    desactivar() {
      let me = this;
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .put("usuario/deactivate", { _id: this.adId }, configuracion)
        .then(function (response) {
          (me.adModal = 0),
            (me.adAccion = 0),
            (me.adNombre = ""),
            (me.adId = ""),
            me.listar();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    activarDesactivarCerrar() {
      this.adModal = 0;
    },


    mostrarDialogoRevisado(item){
        swal({
          title: "Servicio de la Embarcación "+item.embarcacion.nombre +" con folio "+item.ag+" validada",
          text: "El registro cambiara de estatus y quedara en proceso de cotización",
          icon: "warning",
          buttons: true,
          dangerMode: false,
        })
        .then((willDelete) => {
        
          if (willDelete) {
              this.revisado(item._id)
            swal("Registro actualizado", {
              icon: "success",
            });  
          } else{
            swal("Cancelado");
          }
        });
    },

     mostrarDialogoListo(item){
        swal({
          title: "Servicio de la Embarcación "+item.embarcacion.nombre +" con folio "+item.ag+" validada",
          text: "El registro cambiara de estatus a Pendiente y se le notificara al personal administrativo correspondiente para su seguimiento",
          icon: "success",
          buttons: true,
          dangerMode: false,
        })
        .then((willDelete) => {
        
          if (willDelete) {
              this.listo(item._id)
            swal("Registro actualizado", {
              icon: "success",
            });  
          } else{
            swal("Cancelado");
          }
        });
    },
    
    
      mostrarDialogoCotizado(item){
        swal({
          title: "Servicio de agenciamiento cotizado",
          text: "El registro cambiara de estatus y quedara en proceso de estimacion",
          icon: "warning",
           content: "input",
           
          buttons: true,
          dangerMode: false,
        })
        .then((value) => {
      
          if (value) {
              this.cotizado(item._id,value)
              swal('Servicio actualizado');  
          } else{
            swal("Cancelado");
          }
        });
    },

      mostrarDialogoEstimado(item){
        swal({
          title: "Servicio de agenciamiento estimado",
          text: "El registro cambiara de estatus y quedara en proceso de facturación",
          icon: "warning",
           content: "input",
           
          buttons: true,
          dangerMode: false,
        })
        .then((value) => {
      
          if (value) {
              this.estimado(item._id,value)
              swal('Servicio actualizado');  
          } else{
            swal("Cancelado");
          }
        });
    },

      mostrarDialogoFacturado(item){
        swal({
          title: "Servicio de agenciamiento facturado",
          text: "Servicio Finalizado",
          icon: "warning",
           content: "input",
           
          buttons: true,
          dangerMode: false,
        })
        .then((value) => {
      
          if (value) {
              this.facturado(item._id,value)
              swal('Servicio actualizado');  
          } else{
            swal("Cancelado");
          }
        });
    },

    cancelarDialog(item) {
        this.dialog = false;
        this.dialogCotizacion = false;
        this.dialogEstimacion = false;
        this.dialogFacturacion = false;
        this._id = ''
        this.limpiar()
      },
  },
};
</script>

<style>
#factura {
  padding: 20px;
  font-family: Arial, sans-serif;
  font-size: 16px;
}

#table_agencia {
  margin-right: 10px;
}
#imagen {
  width: 100px;
}
#imagen2 {
  width: 90px;
}

#fact {
  font-size: 14px;

  text-align: center;
}

#datos {
  float: left;
  margin-top: 0%;
  margin-left: 15%;
  margin-right: 2%;
  /*text-align: justify;*/
}

#encabezado {
  text-align: center;
  margin-left: 10px;
  margin-right: 10px;
  font-size: 16px;
}

section {
  clear: left;
}

#cliente {
  text-align: left;
}

#facliente {
  width: 40%;
  border-collapse: collapse;
  border-spacing: 0;
  margin-bottom: 15px;
}

#fa {
  color: #ffffff;
  font-size: 14px;
}

#fa2 {
  color: #ffffff;
  font-size: 14px;
}

#facarticulo {
  width: 90%;
  border-collapse: collapse;
  border-spacing: 0;
  padding: 20px;
  margin-bottom: 15px;
  border: 0.5px solid #ddd;
}

#facarticulo thead {
  padding: 20px;
  background: #31467c;
  text-align: center;
  border-bottom: 1px solid #ffffff;
}

#solicitante {
  width: 60%;
  border-collapse: collapse;
  border-spacing: 1;
  padding: 20px;
  margin-bottom: 15px;
  border: 0.5px solid #ddd;
}

#solicitante thead {
  padding: 20px;
  background: #31467c;
  text-align: center;

  border-bottom: 1px solid #ffffff;
}

#gracias {
  text-align: center;
}
#tituloSolicitante {
  background-color: #808285;
  border: 1px solid #ddd;
  color: #ffffff;
}
#tituloPasajeros {
  background-color: #808285;
  border: 1px solid #ddd;
  color: #ffffff;
}
.switch .v-label{
  font-size:12px
}
.inputPequeño .v-label {
  font-size:14px
}

</style>